var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignInImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 719 342",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.2487569%",
    y1: "49.248307%",
    x2: "115.992177%",
    y2: "51.3141557%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.64744473%",
    y1: "49.4413057%",
    x2: "155.382209%",
    y2: "51.1936222%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-71.9970278%",
    y1: "6.26321897%",
    x2: "114.328856%",
    y2: "73.0622505%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.45075705%",
    y1: "32.0536204%",
    x2: "82.8804168%",
    y2: "57.5408941%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.43163099%",
    y1: "31.1151793%",
    x2: "82.8612908%",
    y2: "57.6532247%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.5228897%",
    y1: "53.5801401%",
    x2: "-149.122272%",
    y2: "155.226948%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.46629322%",
    y1: "17.5678139%",
    x2: "192.477497%",
    y2: "132.456948%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.9774081%",
    y1: "77.7546261%",
    x2: "42.7626535%",
    y2: "30.1915772%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.8229607%",
    y1: "46.4408034%",
    x2: "95.4606773%",
    y2: "124.331257%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000463626019%",
    y1: "50.000792%",
    x2: "99.999845%",
    y2: "50.000792%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6FF",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-144.639609%",
    y1: "-232.575151%",
    x2: "141.779092%",
    y2: "183.237887%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "157.83241%",
    y1: "-81.5673299%",
    x2: "-150.76632%",
    y2: "296.175767%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "157.840406%",
    y1: "-81.5607103%",
    x2: "-150.763255%",
    y2: "296.182624%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "157.845756%",
    y1: "-81.5605906%",
    x2: "-150.753051%",
    y2: "296.180814%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "157.84326%",
    y1: "-81.5544676%",
    x2: "-150.755471%",
    y2: "296.18863%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-12.6070659%",
    y1: "34.817006%",
    x2: "64.3854026%",
    y2: "69.0742587%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5F6",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-32.3573135%",
    y1: "69.902598%",
    x2: "200.450833%",
    y2: "12.2683316%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.9759107%",
    y1: "50.0010001%",
    x2: "326.192032%",
    y2: "50.0010001%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.8328467%",
    y1: "45.1878648%",
    x2: "-19.0885033%",
    y2: "62.8702661%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABDCFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.2849551%",
    y1: "6.23380924%",
    x2: "29.6551453%",
    y2: "89.3651996%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.4346857%",
    y1: "50.0000271%",
    x2: "56.5651113%",
    y2: "50.0000271%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.71543217%",
    y1: "82.9211479%",
    x2: "55.798196%",
    y2: "35.7378548%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000321503646%",
    y1: "49.999942%",
    x2: "100.00043%",
    y2: "49.999942%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-33.0419042%",
    y1: "-7.74189774%",
    x2: "108.801448%",
    y2: "98.9074601%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.8278617%",
    y1: "-4.58114242%",
    x2: "89.9330103%",
    y2: "173.97241%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.4840999%",
    y1: "37.5859114%",
    x2: "-46.4290267%",
    y2: "145.893818%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "304.340388%",
    y1: "19.1262444%",
    x2: "-27.0300431%",
    y2: "59.3538774%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.3447644%",
    y1: "36.8787574%",
    x2: "56.6307971%",
    y2: "57.8338052%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5F6",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.7734359%",
    y1: "60.7452557%",
    x2: "19.3333694%",
    y2: "42.6791336%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6FF",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-66.1523328%",
    y1: "-73.2444556%",
    x2: "268.88561%",
    y2: "282.263415%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-66.1537381%",
    y1: "-73.2458338%",
    x2: "268.88561%",
    y2: "282.262036%",
    id: "linearGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-66.1439011%",
    y1: "-73.2375648%",
    x2: "268.895447%",
    y2: "282.268927%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-66.1439011%",
    y1: "-73.2430775%",
    x2: "268.894042%",
    y2: "282.264793%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-29.6741996%",
    y1: "52.2971343%",
    x2: "83.4733943%",
    y2: "48.0012398%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5F6",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9580731%",
    y1: "143.238035%",
    x2: "50.1021998%",
    y2: "-38.3236256%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.7078969%",
    y1: "8.32305088%",
    x2: "54.1880596%",
    y2: "58.0065895%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "117.491294%",
    y1: "50.7051566%",
    x2: "-29.0833939%",
    y2: "49.2040852%",
    id: "linearGradient-37"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.5804646%",
    y1: "85.9519246%",
    x2: "47.9956825%",
    y2: "221.759477%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-13.755132%",
    y1: "-9.91750306%",
    x2: "161.781267%",
    y2: "155.057903%",
    id: "linearGradient-39"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "250.768477%",
    y1: "-232.576247%",
    x2: "-44.6668266%",
    y2: "183.240811%",
    id: "linearGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.0907056%",
    y1: "6.52782959%",
    x2: "48.1062157%",
    y2: "125.474305%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.5804783%",
    y1: "85.9518573%",
    x2: "47.9957018%",
    y2: "221.759174%",
    id: "linearGradient-42"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "250.771654%",
    y1: "-232.576247%",
    x2: "-44.6636504%",
    y2: "183.239996%",
    id: "linearGradient-43"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-23.7930794%",
    y1: "-14.2856135%",
    x2: "235.871635%",
    y2: "211.906892%",
    id: "linearGradient-44"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.0909462%",
    y1: "6.52795673%",
    x2: "48.1057905%",
    y2: "125.474559%",
    id: "linearGradient-45"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1963216%",
    y1: "-14.5937632%",
    x2: "72.4739879%",
    y2: "236.03628%",
    id: "linearGradient-46"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1956541%",
    y1: "-14.5953887%",
    x2: "72.4759104%",
    y2: "236.045374%",
    id: "linearGradient-47"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1956541%",
    y1: "-14.59639%",
    x2: "72.4759104%",
    y2: "236.044873%",
    id: "linearGradient-48"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1961304%",
    y1: "-14.594888%",
    x2: "72.4763867%",
    y2: "236.046375%",
    id: "linearGradient-49"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1960165%",
    y1: "-14.5962248%",
    x2: "72.4767147%",
    y2: "236.046366%",
    id: "linearGradient-50"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1967979%",
    y1: "-14.5902587%",
    x2: "72.4744642%",
    y2: "236.039784%",
    id: "linearGradient-51"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.8747915%",
    y1: "43.7472484%",
    x2: "72.9180876%",
    y2: "89.2039414%",
    id: "linearGradient-52"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "220.727165%",
    y1: "7.8733558%",
    x2: "116.917226%",
    y2: "33.5116867%",
    id: "linearGradient-53"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.846609%",
    y1: "47.8390728%",
    x2: "409.660011%",
    y2: "73.1521152%",
    id: "linearGradient-54"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-10.72307%",
    y1: "46.1323051%",
    x2: "383.081896%",
    y2: "71.4442204%",
    id: "linearGradient-55"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-36.9959368%",
    y1: "44.4432474%",
    x2: "356.809239%",
    y2: "69.7552322%",
    id: "linearGradient-56"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.05244369%",
    y1: "-20.6181921%",
    x2: "126.802177%",
    y2: "148.507774%",
    id: "linearGradient-57"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-39.3105443%",
    y1: "-24.3271342%",
    x2: "232.48775%",
    y2: "201.866186%",
    id: "linearGradient-58"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "250.771654%",
    y1: "-232.574618%",
    x2: "-44.6636504%",
    y2: "183.242441%",
    id: "linearGradient-59"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.767163757%",
    y1: "-12.5501023%",
    x2: "142.413021%",
    y2: "163.838937%",
    id: "linearGradient-60"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-50.9833171%",
    y1: "25.4530846%",
    x2: "67.2057595%",
    y2: "69.5173362%",
    id: "linearGradient-61"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.3338907%",
    y1: "32.0719257%",
    x2: "59.7204595%",
    y2: "55.6281243%",
    id: "linearGradient-62"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02B0F8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-21.9918093%",
    y1: "50.0004816%",
    x2: "152.934988%",
    y2: "50.0004816%",
    id: "linearGradient-63"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.3352704%",
    y1: "50.0004816%",
    x2: "159.960925%",
    y2: "50.0004816%",
    id: "linearGradient-64"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-38.3059596%",
    y1: "50.0003255%",
    x2: "61.6943536%",
    y2: "50.0003255%",
    id: "linearGradient-65"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-25.44021%",
    y1: "-63.8452926%",
    x2: "115.97981%",
    y2: "149.568264%",
    id: "linearGradient-66"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109CFF",
    offset: "9.98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33ACFF",
    offset: "28.51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BC6FF",
    offset: "53.56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFF",
    offset: "83.84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84917658%",
    y1: "14.6102168%",
    x2: "194.195351%",
    y2: "163.020383%",
    id: "linearGradient-67"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.588106%",
    y1: "35.8115703%",
    x2: "126.03008%",
    y2: "87.9682437%",
    id: "linearGradient-68"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2364.47687%",
    y1: "49.9984162%",
    x2: "1315.60272%",
    y2: "49.9984162%",
    id: "linearGradient-69"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00442164839%",
    y1: "49.9992081%",
    x2: "1048.78493%",
    y2: "49.9992081%",
    id: "linearGradient-70"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000884407889%",
    y1: "50%",
    x2: "1048.87238%",
    y2: "50%",
    id: "linearGradient-71"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.5878713%",
    y1: "35.8113373%",
    x2: "126.030556%",
    y2: "87.9688312%",
    id: "linearGradient-72"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "5.58921772%",
    y1: "50.0009465%",
    x2: "-94.4110061%",
    y2: "50.0009465%",
    id: "linearGradient-73"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6FF",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.036399%",
    y1: "-232.581991%",
    x2: "-45.265351%",
    y2: "183.236189%",
    id: "linearGradient-74"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "215.607423%",
    y1: "94.8569003%",
    x2: "-263.656823%",
    y2: "-22.4998557%",
    id: "linearGradient-75"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "215.606111%",
    y1: "94.8639071%",
    x2: "-263.65568%",
    y2: "-22.4884331%",
    id: "linearGradient-76"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "215.608838%",
    y1: "94.8812302%",
    x2: "-263.655409%",
    y2: "-22.4755258%",
    id: "linearGradient-77"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "215.618046%",
    y1: "94.8445753%",
    x2: "-263.645228%",
    y2: "-22.506953%",
    id: "linearGradient-78"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-29.6742892%",
    y1: "52.2866399%",
    x2: "83.473599%",
    y2: "48.0103769%",
    id: "linearGradient-79"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.1693181%",
    y1: "-13.601386%",
    x2: "48.1871868%",
    y2: "41.4994331%",
    id: "linearGradient-80"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.8833639%",
    y1: "-1.50403511%",
    x2: "55.960959%",
    y2: "86.2143936%",
    id: "linearGradient-81"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "117.491294%",
    y1: "50.7019551%",
    x2: "-29.0833939%",
    y2: "49.2077317%",
    id: "linearGradient-82"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7840383%",
    y1: "67.9468637%",
    x2: "-32.0560622%",
    y2: "135.540227%",
    id: "linearGradient-83"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7840383%",
    y1: "67.9468637%",
    x2: "-32.0560622%",
    y2: "135.540312%",
    id: "linearGradient-84"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7840383%",
    y1: "67.9469489%",
    x2: "-32.0560622%",
    y2: "135.540312%",
    id: "linearGradient-85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0467835%",
    y1: "53.9912194%",
    x2: "51.6388622%",
    y2: "189.798731%",
    id: "linearGradient-86"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.862261%",
    y1: "51.8242335%",
    x2: "85.325456%",
    y2: "248.276102%",
    id: "linearGradient-87"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.695103%",
    y1: "-232.578691%",
    x2: "-45.0999953%",
    y2: "183.237552%",
    id: "linearGradient-88"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.658792%",
    y1: "-232.550084%",
    x2: "-45.0820134%",
    y2: "183.236459%",
    id: "linearGradient-89"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.654529%",
    y1: "-232.551445%",
    x2: "-45.0862767%",
    y2: "183.235098%",
    id: "linearGradient-90"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.656661%",
    y1: "-232.555528%",
    x2: "-45.0841451%",
    y2: "183.231016%",
    id: "linearGradient-91"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.79494691%",
    y1: "26.4440406%",
    x2: "110.344323%",
    y2: "79.3318676%",
    id: "linearGradient-92"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "220.646552%",
    y1: "7.54639031%",
    x2: "116.83811%",
    y2: "33.4930677%",
    id: "linearGradient-93"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.761396%",
    y1: "62.899935%",
    x2: "54.0296939%",
    y2: "8.00535478%",
    id: "linearGradient-94"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.761396%",
    y1: "62.8996656%",
    x2: "54.0296939%",
    y2: "8.0044459%",
    id: "linearGradient-95"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.9042669%",
    y1: "6.52795673%",
    x2: "51.9025008%",
    y2: "125.474432%",
    id: "linearGradient-96"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.6758758%",
    y1: "-76.612641%",
    x2: "56.2379432%",
    y2: "174.884857%",
    id: "linearGradient-97"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-77.3875231%",
    y1: "-128.473283%",
    x2: "219.407576%",
    y2: "287.342961%",
    id: "linearGradient-98"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-29.6387397%",
    y1: "-61.574625%",
    x2: "267.156359%",
    y2: "354.240804%",
    id: "linearGradient-99"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-151.693827%",
    y1: "-232.575432%",
    x2: "145.100633%",
    y2: "183.241626%",
    id: "linearGradient-100"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.2470944%",
    y1: "24.2258064%",
    x2: "52.0035956%",
    y2: "92.1396462%",
    id: "linearGradient-101"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFFFC",
    stopOpacity: 0.1976,
    offset: "20.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFFFA",
    stopOpacity: 0.413,
    offset: "41.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6FFF8",
    stopOpacity: 0.6227,
    offset: "62.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99FFF7",
    stopOpacity: 0.8221,
    offset: "82.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.03%",
    y1: "101.968589%",
    x2: "0.03%",
    y2: "-1.96825608%",
    id: "linearGradient-102"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFFF6",
    stopOpacity: 0.1856,
    offset: "18.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1FFEE",
    stopOpacity: 0.3682,
    offset: "37.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFE8",
    stopOpacity: 0.5443,
    offset: "54.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68FFE4",
    stopOpacity: 0.7119,
    offset: "71.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AFFE1",
    stopOpacity: 0.8677,
    offset: "86.84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FFE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.03%",
    y1: "102.799441%",
    x2: "0.03%",
    y2: "-2.79944125%",
    id: "linearGradient-103"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFFF6",
    stopOpacity: 0.1856,
    offset: "18.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1FFEE",
    stopOpacity: 0.3682,
    offset: "37.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFE8",
    stopOpacity: 0.5443,
    offset: "54.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68FFE4",
    stopOpacity: 0.7119,
    offset: "71.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AFFE1",
    stopOpacity: 0.8677,
    offset: "86.84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FFE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.03%",
    y1: "101.967756%",
    x2: "-0.03%",
    y2: "-1.96925537%",
    id: "linearGradient-104"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFFF6",
    stopOpacity: 0.1856,
    offset: "18.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1FFEE",
    stopOpacity: 0.3682,
    offset: "37.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFE8",
    stopOpacity: 0.5443,
    offset: "54.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68FFE4",
    stopOpacity: 0.7119,
    offset: "71.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AFFE1",
    stopOpacity: 0.8677,
    offset: "86.84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FFE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.652397%",
    y1: "-232.547362%",
    x2: "-45.0884083%",
    y2: "183.239181%",
    id: "linearGradient-105"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.658792%",
    y1: "-232.547362%",
    x2: "-45.0820134%",
    y2: "183.239181%",
    id: "linearGradient-106"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "251.660924%",
    y1: "-232.552806%",
    x2: "-45.0798818%",
    y2: "183.233738%",
    id: "linearGradient-107"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-77.2956286%",
    y1: "-128.338842%",
    x2: "219.49947%",
    y2: "287.477402%",
    id: "linearGradient-108"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.3824745%",
    y1: "40.0477235%",
    x2: "56.3170405%",
    y2: "57.8854348%",
    id: "linearGradient-109"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#016EED",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-35.5411882%",
    y1: "50.0001698%",
    x2: "64.458857%",
    y2: "50.0001698%",
    id: "linearGradient-110"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6FF",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-29.6741394%",
    y1: "52.2716112%",
    x2: "83.4736989%",
    y2: "48.0234535%",
    id: "linearGradient-111"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.764818%",
    y1: "121.25823%",
    x2: "31.918381%",
    y2: "2.34323149%",
    id: "linearGradient-112"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.39362608%",
    y1: "-11.1698617%",
    x2: "48.8473688%",
    y2: "47.5778045%",
    id: "linearGradient-113"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.6687233%",
    y1: "36.8566785%",
    x2: "138.463356%",
    y2: "89.9541637%",
    id: "linearGradient-114"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.8401519%",
    y1: "54.0437371%",
    x2: "44.3982177%",
    y2: "191.662502%",
    id: "linearGradient-115"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.990161%",
    y1: "-232.565484%",
    x2: "-45.7153635%",
    y2: "183.223795%",
    id: "linearGradient-116"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.990161%",
    y1: "-232.558968%",
    x2: "-45.7153635%",
    y2: "183.229007%",
    id: "linearGradient-117"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.990161%",
    y1: "-232.553756%",
    x2: "-45.7153635%",
    y2: "183.235523%",
    id: "linearGradient-118"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.7798557%",
    y1: "114.936358%",
    x2: "151.257413%",
    y2: "312.01712%",
    id: "linearGradient-119"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.6129812%",
    y1: "-345.768144%",
    x2: "86.9793994%",
    y2: "235.155098%",
    id: "linearGradient-120"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.6050158%",
    y1: "-345.762852%",
    x2: "86.9873541%",
    y2: "235.16039%",
    id: "linearGradient-121"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.1436472%",
    y1: "34.0513523%",
    x2: "-49.2013874%",
    y2: "162.30068%",
    id: "linearGradient-122"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0831388%",
    y1: "-45.4152867%",
    x2: "18.370245%",
    y2: "158.367686%",
    id: "linearGradient-123"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0878628%",
    y1: "-45.4148351%",
    x2: "18.3624819%",
    y2: "158.368138%",
    id: "linearGradient-124"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "130.887027%",
    y1: "-26.8487285%",
    x2: "-41.6503574%",
    y2: "137.288482%",
    id: "linearGradient-125"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "131.599041%",
    y1: "-29.5490433%",
    x2: "-42.4045468%",
    y2: "140.353691%",
    id: "linearGradient-126"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.465096%",
    y1: "-55.3837658%",
    x2: "-12.370503%",
    y2: "169.678672%",
    id: "linearGradient-127"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.452587%",
    y1: "-55.4075164%",
    x2: "-12.3806952%",
    y2: "169.653225%",
    id: "linearGradient-128"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.46157%",
    y1: "-55.4126058%",
    x2: "-12.3763455%",
    y2: "169.651529%",
    id: "linearGradient-129"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.1436472%",
    y1: "34.0512173%",
    x2: "-49.2013874%",
    y2: "162.300545%",
    id: "linearGradient-130"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0831388%",
    y1: "-45.4152292%",
    x2: "18.370245%",
    y2: "158.367744%",
    id: "linearGradient-131"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0878628%",
    y1: "-45.4147775%",
    x2: "18.3621396%",
    y2: "158.368647%",
    id: "linearGradient-132"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "132.327144%",
    y1: "-32.3427252%",
    x2: "-43.1701262%",
    y2: "143.529239%",
    id: "linearGradient-133"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "133.725477%",
    y1: "-37.8136749%",
    x2: "-44.6511475%",
    y2: "149.740563%",
    id: "linearGradient-134"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.465096%",
    y1: "-55.3874675%",
    x2: "-12.370503%",
    y2: "169.674971%",
    id: "linearGradient-135"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.452587%",
    y1: "-55.4112181%",
    x2: "-12.3830119%",
    y2: "169.65122%",
    id: "linearGradient-136"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.46157%",
    y1: "-55.3823781%",
    x2: "-12.3763455%",
    y2: "169.681756%",
    id: "linearGradient-137"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.764818%",
    y1: "121.257918%",
    x2: "31.9184474%",
    y2: "2.34299738%",
    id: "linearGradient-138"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.81960966%",
    y1: "-7.16607267%",
    x2: "50.5010365%",
    y2: "49.942034%",
    id: "linearGradient-139"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-17.4915947%",
    y1: "50.6968997%",
    x2: "129.083144%",
    y2: "49.2125386%",
    id: "linearGradient-140"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.840303%",
    y1: "54.0447736%",
    x2: "44.3984157%",
    y2: "191.662658%",
    id: "linearGradient-141"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.99427%",
    y1: "-232.555059%",
    x2: "-45.7112545%",
    y2: "183.23422%",
    id: "linearGradient-142"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.99427%",
    y1: "-232.562878%",
    x2: "-45.7112545%",
    y2: "183.227704%",
    id: "linearGradient-143"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.993243%",
    y1: "-232.556362%",
    x2: "-45.7112545%",
    y2: "183.23422%",
    id: "linearGradient-144"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.1432678%",
    y1: "34.0514841%",
    x2: "-49.2017668%",
    y2: "162.300812%",
    id: "linearGradient-145"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0825357%",
    y1: "-45.4147756%",
    x2: "18.3692996%",
    y2: "158.368649%",
    id: "linearGradient-146"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0869172%",
    y1: "-45.4138724%",
    x2: "18.3618787%",
    y2: "158.368649%",
    id: "linearGradient-147"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "130.891095%",
    y1: "-26.8540089%",
    x2: "-41.6526642%",
    y2: "137.294863%",
    id: "linearGradient-148"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "131.602388%",
    y1: "-29.5490689%",
    x2: "-42.4011994%",
    y2: "140.353665%",
    id: "linearGradient-149"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.461014%",
    y1: "-55.3779283%",
    x2: "-12.3769019%",
    y2: "169.682289%",
    id: "linearGradient-150"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.47294%",
    y1: "-55.3999824%",
    x2: "-12.3603428%",
    y2: "169.656842%",
    id: "linearGradient-151"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.481923%",
    y1: "-55.4050718%",
    x2: "-12.3536764%",
    y2: "169.653449%",
    id: "linearGradient-152"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.1432678%",
    y1: "34.051492%",
    x2: "-49.2017668%",
    y2: "162.300677%",
    id: "linearGradient-153"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0825357%",
    y1: "-45.4147181%",
    x2: "18.3692996%",
    y2: "158.367663%",
    id: "linearGradient-154"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.0869172%",
    y1: "-45.4138148%",
    x2: "18.3618787%",
    y2: "158.367663%",
    id: "linearGradient-155"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "132.332893%",
    y1: "-32.3510804%",
    x2: "-43.1732251%",
    y2: "143.539772%",
    id: "linearGradient-156"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "133.733812%",
    y1: "-37.8257526%",
    x2: "-44.6559724%",
    y2: "149.754555%",
    id: "linearGradient-157"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.461014%",
    y1: "-55.3855478%",
    x2: "-12.3769019%",
    y2: "169.682505%",
    id: "linearGradient-158"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.47294%",
    y1: "-55.4076019%",
    x2: "-12.3626595%",
    y2: "169.658754%",
    id: "linearGradient-159"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.481923%",
    y1: "-55.3787619%",
    x2: "-12.3536764%",
    y2: "169.687594%",
    id: "linearGradient-160"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.7798557%",
    y1: "114.935738%",
    x2: "151.257413%",
    y2: "312.016654%",
    id: "linearGradient-161"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.621196%",
    y1: "-345.727884%",
    x2: "86.9723999%",
    y2: "235.19451%",
    id: "linearGradient-162"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.6132305%",
    y1: "-345.735623%",
    x2: "86.9803546%",
    y2: "235.186771%",
    id: "linearGradient-163"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.6168258%",
    y1: "-345.740202%",
    x2: "86.9759888%",
    y2: "235.181628%",
    id: "linearGradient-164"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.9993469%",
    y1: "50.0000082%",
    x2: "-0.00124163117%",
    y2: "50.0000082%",
    id: "linearGradient-165"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-149.598198%",
    y1: "-232.55419%",
    x2: "144.109951%",
    y2: "183.233489%",
    id: "linearGradient-166"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-29.6745389%",
    y1: "52.2992459%",
    x2: "83.4733493%",
    y2: "47.999254%",
    id: "linearGradient-167"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.814563%",
    y1: "-10.7534274%",
    x2: "53.0459769%",
    y2: "72.3494212%",
    id: "linearGradient-168"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.7757853%",
    y1: "-2.97374626%",
    x2: "57.4358367%",
    y2: "102.562493%",
    id: "linearGradient-169"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "117.491578%",
    y1: "50.7056283%",
    x2: "-29.0833892%",
    y2: "49.2031143%",
    id: "linearGradient-170"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7839413%",
    y1: "68.0466591%",
    x2: "-32.05703%",
    y2: "136.016527%",
    id: "linearGradient-171"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7839413%",
    y1: "68.0466591%",
    x2: "-32.0571643%",
    y2: "136.016527%",
    id: "linearGradient-172"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0465392%",
    y1: "53.9912074%",
    x2: "51.6298002%",
    y2: "189.798484%",
    id: "linearGradient-173"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.2650567%",
    y1: "-96.3362937%",
    x2: "58.5319759%",
    y2: "100.115411%",
    id: "linearGradient-174"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "250.575213%",
    y1: "-232.576247%",
    x2: "-44.5775661%",
    y2: "183.239181%",
    id: "linearGradient-175"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.1463377%",
    y1: "27.5313838%",
    x2: "132.305685%",
    y2: "100.213236%",
    id: "linearGradient-176"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "220.646985%",
    y1: "7.3102516%",
    x2: "116.838542%",
    y2: "33.4013471%",
    id: "linearGradient-177"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.7621377%",
    y1: "62.9711667%",
    x2: "54.0304003%",
    y2: "7.77123396%",
    id: "linearGradient-178"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.7621377%",
    y1: "62.9715767%",
    x2: "54.0304003%",
    y2: "7.771644%",
    id: "linearGradient-179"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.9100165%",
    y1: "6.528211%",
    x2: "51.8923101%",
    y2: "125.474686%",
    id: "linearGradient-180"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9969187%",
    y1: "172.931287%",
    x2: "49.9969187%",
    y2: "14.2111815%",
    id: "linearGradient-181"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6583",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7688",
    offset: "13.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA797",
    offset: "52.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A0",
    offset: "83.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00052561474%",
    y1: "50.0008062%",
    x2: "100.001569%",
    y2: "50.0008062%",
    id: "linearGradient-182"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "264.57987%",
    y1: "-232.549642%",
    x2: "-51.177308%",
    y2: "183.23579%",
    id: "linearGradient-183"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-46.1061751%",
    y1: "68.6294545%",
    x2: "79.1539801%",
    y2: "39.138372%",
    id: "linearGradient-184"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-21.9930867%",
    y1: "49.9998796%",
    x2: "152.935902%",
    y2: "49.9998796%",
    id: "linearGradient-185"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.3350199%",
    y1: "50%",
    x2: "159.961301%",
    y2: "50%",
    id: "linearGradient-186"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-38.3057717%",
    y1: "49.9998915%",
    x2: "61.6944789%",
    y2: "49.9998915%",
    id: "linearGradient-187"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-25.870151%",
    y1: "-63.8466632%",
    x2: "116.355187%",
    y2: "149.569583%",
    id: "linearGradient-188"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#109CFF",
    offset: "9.98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33ACFF",
    offset: "28.51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BC6FF",
    offset: "53.56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFF",
    offset: "83.84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.59394942%",
    y1: "14.6108188%",
    x2: "195.009118%",
    y2: "163.020985%",
    id: "linearGradient-189"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.5882312%",
    y1: "35.8915456%",
    x2: "126.030205%",
    y2: "87.7542298%",
    id: "linearGradient-190"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.003538%",
    y1: "49.9992082%",
    x2: "-948.869727%",
    y2: "49.9992082%",
    id: "linearGradient-191"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.00265322367%",
    y1: "50%",
    x2: "1048.87061%",
    y2: "50%",
    id: "linearGradient-192"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000884329678%",
    y1: "50.0007919%",
    x2: "1048.78139%",
    y2: "50.0007919%",
    id: "linearGradient-193"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.6351683%",
    y1: "-79.2362077%",
    x2: "64.2849801%",
    y2: "135.093418%",
    id: "linearGradient-194"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "223.910552%",
    y1: "372.892796%",
    x2: "-0.852783683%",
    y2: "-76.7460981%",
    id: "linearGradient-195"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "221.341959%",
    y1: "310.087006%",
    x2: "-22.3254691%",
    y2: "-59.6161448%",
    id: "linearGradient-196"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "218.607226%",
    y1: "298.89526%",
    x2: "-21.1489101%",
    y2: "-54.900284%",
    id: "linearGradient-197"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "218.607226%",
    y1: "298.885048%",
    x2: "-21.1489101%",
    y2: "-54.8958696%",
    id: "linearGradient-198"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "218.607226%",
    y1: "298.89518%",
    x2: "-21.1489101%",
    y2: "-54.9001715%",
    id: "linearGradient-199"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "218.607226%",
    y1: "298.885353%",
    x2: "-21.1489101%",
    y2: "-54.8961426%",
    id: "linearGradient-200"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "218.607003%",
    y1: "298.894824%",
    x2: "-21.1489101%",
    y2: "-54.900059%",
    id: "linearGradient-201"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "218.607003%",
    y1: "298.885189%",
    x2: "-21.1489101%",
    y2: "-54.8960301%",
    id: "linearGradient-202"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000358369975%",
    y1: "49.9997001%",
    x2: "99.9989728%",
    y2: "49.9997001%",
    id: "linearGradient-203"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7466015%",
    y1: "81.7044229%",
    x2: "48.0948394%",
    y2: "26.5068534%",
    id: "linearGradient-204"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ADFFF",
    stopOpacity: 0.56,
    offset: "49.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.584274%",
    y1: "79.2118669%",
    x2: "45.9214999%",
    y2: "14.6217794%",
    id: "linearGradient-205"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6FF",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "252.882591%",
    y1: "-232.577217%",
    x2: "-45.6619805%",
    y2: "183.240962%",
    id: "linearGradient-206"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "142.689066%",
    y1: "50.0006376%",
    x2: "242.689237%",
    y2: "50.0006376%",
    id: "linearGradient-207"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-144.637547%",
    y1: "-232.571741%",
    x2: "141.781153%",
    y2: "183.240615%",
    id: "linearGradient-208"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FFEA",
    offset: "11.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFD5",
    offset: "52.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75FFC7",
    offset: "82.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.8508209%",
    y1: "38.1963586%",
    x2: "63.1995146%",
    y2: "62.7538138%",
    id: "linearGradient-209"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A8F5",
    stopOpacity: 0,
    offset: "99.95%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "80.1152567%",
    y1: "37.219101%",
    x2: "-15.2447404%",
    y2: "68.2648019%",
    id: "linearGradient-210"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC6FF",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "181.514216%",
    y1: "-100.058982%",
    x2: "-14.6775403%",
    y2: "123.751285%",
    id: "linearGradient-211"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.2969584%",
    y1: "46.1531918%",
    x2: "-142.889972%",
    y2: "269.960705%",
    id: "linearGradient-212"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "217.827484%",
    y1: "81.2771022%",
    x2: "-268.170817%",
    y2: "1.9484206%",
    id: "linearGradient-213"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F4FF",
    offset: "14.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFBFF",
    offset: "66.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.36520853%",
    y1: "50.1623019%",
    x2: "99.019996%",
    y2: "49.8536844%",
    id: "linearGradient-214"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.0119803%",
    y1: "27.1888575%",
    x2: "18.7177934%",
    y2: "90.0876542%",
    id: "linearGradient-215"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "128.79504%",
    y1: "88.5661738%",
    x2: "21.3359674%",
    y2: "35.9703054%",
    id: "linearGradient-216"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.9026052%",
    y1: "43.5163579%",
    x2: "89.3629856%",
    y2: "56.3337112%",
    id: "linearGradient-217"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001FD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86D3FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.0119036%",
    y1: "27.1886949%",
    x2: "18.7177696%",
    y2: "90.087577%",
    id: "linearGradient-218"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "119.389457%",
    y1: "83.9625147%",
    x2: "11.9305087%",
    y2: "31.3670734%",
    id: "linearGradient-219"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-15.9492597%",
    y1: "59.467718%",
    x2: "94.5993263%",
    y2: "42.6395301%",
    id: "linearGradient-220"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BFF",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D8FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.8745336%",
    y1: "8.47941176%",
    x2: "59.0146206%",
    y2: "102.530065%",
    id: "linearGradient-221"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "151.448036%",
    y1: "102.729501%",
    x2: "57.7517293%",
    y2: "48.241191%",
    id: "linearGradient-222"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.8434602%",
    y1: "23.8389701%",
    x2: "117.709247%",
    y2: "93.4195644%",
    id: "linearGradient-223"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "159.992836%",
    y1: "73.6355135%",
    x2: "26.5523555%",
    y2: "37.3338063%",
    id: "linearGradient-224"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.8907884%",
    y1: "36.6404465%",
    x2: "145.820011%",
    y2: "134.655284%",
    id: "linearGradient-225"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-14.7713667%",
    y1: "-6.23712378%",
    x2: "96.1496007%",
    y2: "90.068959%",
    id: "linearGradient-226"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-35.0495513%",
    y1: "14.584486%",
    x2: "141.188841%",
    y2: "87.9556124%",
    id: "linearGradient-227"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.8509559%",
    y1: "52.9358022%",
    x2: "-139.27819%",
    y2: "136.220707%",
    id: "linearGradient-228"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.9529565%",
    y1: "0.681446082%",
    x2: "176.158705%",
    y2: "275.510421%",
    id: "linearGradient-229"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.5168108%",
    y1: "37.5612963%",
    x2: "146.429346%",
    y2: "146.083647%",
    id: "linearGradient-230"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-203.85607%",
    y1: "19.1228844%",
    x2: "126.884111%",
    y2: "59.3505706%",
    id: "linearGradient-231"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.5585743%",
    y1: "-1.69510961%",
    x2: "158.82383%",
    y2: "105.094565%",
    id: "linearGradient-232"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.987812%",
    y1: "12.8289449%",
    x2: "150.0192%",
    y2: "89.6462226%",
    id: "linearGradient-233"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6C0",
    offset: "31.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39496",
    offset: "63.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC757C",
    offset: "86.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A72",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.8265672%",
    y1: "-79.2985332%",
    x2: "42.8896433%",
    y2: "134.327258%",
    id: "linearGradient-234"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-48.338328%",
    y1: "360.157081%",
    x2: "76.0539341%",
    y2: "-76.1159985%",
    id: "linearGradient-235"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-60.8065389%",
    y1: "483.239784%",
    x2: "95.4693112%",
    y2: "-131.026713%",
    id: "linearGradient-236"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-59.2722723%",
    y1: "470.034551%",
    x2: "95.0734908%",
    y2: "-125.802623%",
    id: "linearGradient-237"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-59.2673568%",
    y1: "470.018789%",
    x2: "95.0720793%",
    y2: "-125.796211%",
    id: "linearGradient-238"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-59.2689703%",
    y1: "469.999854%",
    x2: "95.0704658%",
    y2: "-125.788472%",
    id: "linearGradient-239"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-59.2705837%",
    y1: "470.018526%",
    x2: "95.0688524%",
    y2: "-125.796474%",
    id: "linearGradient-240"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-59.2721972%",
    y1: "469.999591%",
    x2: "95.0672389%",
    y2: "-125.788735%",
    id: "linearGradient-241"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-59.2738106%",
    y1: "470.018264%",
    x2: "95.0656255%",
    y2: "-125.796736%",
    id: "linearGradient-242"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "81.5071091%",
    y1: "-72.1321742%",
    x2: "27.9384294%",
    y2: "129.628817%",
    id: "linearGradient-243"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-49.8030448%",
    y1: "400.208173%",
    x2: "79.6010333%",
    y2: "-90.5793933%",
    id: "linearGradient-244"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.50909193%",
    y1: "402.840246%",
    x2: "67.1626707%",
    y2: "-98.3725034%",
    id: "linearGradient-245"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.2662081%",
    y1: "401.347417%",
    x2: "66.8228738%",
    y2: "-97.8087082%",
    id: "linearGradient-246"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.2667042%",
    y1: "401.347075%",
    x2: "66.8233699%",
    y2: "-97.8090499%",
    id: "linearGradient-247"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.2671695%",
    y1: "401.356362%",
    x2: "66.8230686%",
    y2: "-97.8111983%",
    id: "linearGradient-248"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.2665319%",
    y1: "401.349632%",
    x2: "66.8231976%",
    y2: "-97.8064938%",
    id: "linearGradient-249"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.267028%",
    y1: "401.34929%",
    x2: "66.8236937%",
    y2: "-97.8068355%",
    id: "linearGradient-250"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.2692823%",
    y1: "401.349541%",
    x2: "66.8226349%",
    y2: "-97.8067819%",
    id: "linearGradient-251"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.9241977%",
    y1: "49.4152136%",
    x2: "102.914761%",
    y2: "60.9314568%",
    id: "linearGradient-252"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A92",
    offset: "2.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F96",
    stopOpacity: 0.8586,
    offset: "15.94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002DA0",
    stopOpacity: 0.6919,
    offset: "32.26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0045B1",
    stopOpacity: 0.5124,
    offset: "49.84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066C9",
    stopOpacity: 0.3238,
    offset: "68.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090E7",
    stopOpacity: 0.1303,
    offset: "87.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.2979486%",
    y1: "38.5676904%",
    x2: "111.267682%",
    y2: "72.0901055%",
    id: "linearGradient-253"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.5235912%",
    y1: "20.9560613%",
    x2: "74.9243875%",
    y2: "106.892481%",
    id: "linearGradient-254"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0396FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36AEFF",
    offset: "16.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CAFF",
    offset: "38.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E0FF",
    offset: "58.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1FF",
    offset: "76.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFAFF",
    offset: "90.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.6523183%",
    y1: "30.1380138%",
    x2: "92.6440738%",
    y2: "77.5996351%",
    id: "linearGradient-255"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-23.0922364%",
    y1: "39.477579%",
    x2: "96.2917266%",
    y2: "56.7392493%",
    id: "linearGradient-256"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FF94",
    offset: "0.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1050.46817%",
    y1: "-74.3080019%",
    x2: "-937.253588%",
    y2: "-61.5350202%",
    id: "linearGradient-257"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000288521573%",
    y1: "49.9999637%",
    x2: "100.000296%",
    y2: "49.9999637%",
    id: "linearGradient-258"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "108.21036%",
    y1: "31.4048721%",
    x2: "3.6598283%",
    y2: "64.8025017%",
    id: "linearGradient-259"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-28.7281058%",
    y1: "50.0017484%",
    x2: "81.4927587%",
    y2: "50.0017484%",
    id: "linearGradient-260"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00327F",
    offset: "0.04607372%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A7F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.6170008%",
    y1: "54.4206183%",
    x2: "-3.32629053%",
    y2: "38.245022%",
    id: "linearGradient-261"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2275",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.627344%",
    y1: "112.869777%",
    x2: "27.6813571%",
    y2: "-72.6276791%",
    id: "linearGradient-262"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6583",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7688",
    offset: "13.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA797",
    offset: "52.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A0",
    offset: "83.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "105.815071%",
    y1: "74.6800915%",
    x2: "40.4192475%",
    y2: "39.7412001%",
    id: "linearGradient-263"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2275",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.453575%",
    y1: "91.2590996%",
    x2: "22.9794639%",
    y2: "-32.3965001%",
    id: "linearGradient-264"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6583",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7688",
    offset: "13.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA797",
    offset: "52.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A0",
    offset: "83.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.7264425%",
    y1: "46.785239%",
    x2: "-107.256306%",
    y2: "-95.6030745%",
    id: "linearGradient-265"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6583",
    offset: "0.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7688",
    offset: "13.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA797",
    offset: "52.77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A0",
    offset: "83.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-In",
    transform: "translate(-1.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tube_1",
    transform: "translate(308.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.656489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    cx: 69.9658112,
    cy: 90.1587557,
    rx: 58.6918427,
    ry: 19.7451832
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.216783, 0.000000)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.224171329,24.5512061 L0.227328671,24.5512061 C0.295437063,18.3994427 4.45997203,12.2463282 12.7168741,7.53803817 C29.2987867,-1.91772519 56.0996643,-1.96591603 72.5778357,7.43039695 C80.8505245,12.1476947 84.9474021,18.3485496 84.8792937,24.5512061 L84.8820797,24.5512061 L84.8810979,81.3074046 L84.8810979,81.3074046 C84.9505594,88.0050305 81.3394615,94.7657099 72.3892972,99.8698855 C55.8073846,109.325649 29.006507,109.37384 12.5283357,99.9775267 C3.56644406,94.8670458 0.0866013986,88.3094885 0.223269231,81.3074046 L0.223269231,81.3074046 L0.224171329,24.5512061 Z",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5283357,41.6733664 C29.006507,51.0696794 55.8073846,51.0214885 72.3892972,41.5657252 C88.9712098,32.1099618 89.0555559,16.8271603 72.5773846,7.43084733 C56.0992133,-1.96546565 29.2983357,-1.91727481 12.7164231,7.53848855 C-3.86548951,16.9942519 -3.94983566,32.2770534 12.5283357,41.6733664 Z",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 37.381679)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.324259091,
    y: 0.323779389,
    width: 99.2307692,
    height: 40.5343511,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43644406,7.48624427 C7.43644406,7.48624427 21.3670909,24.8016183 50.1945315,23.9265267 C81.9204126,22.9636107 92.0983322,8.21045802 92.0983322,8.21045802 L92.0992343,19.1722977 C92.0992343,19.1722977 76.3621364,33.6286489 49.7890385,33.6286489 C20.8001224,33.6286489 7.43644406,17.777916 7.43644406,17.777916 L7.43644406,7.48624427 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 59.450382)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.324259091,
    y: 0.323779389,
    width: 99.2307692,
    height: 41.8854962,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43824825,7.46642748 C7.43824825,7.46642748 21.4902273,25.8591145 50.3181189,24.9840229 C82.044,24.0211069 92.1001364,8.19064122 92.1001364,8.19064122 L92.1010385,19.1524809 C92.1010385,19.1524809 76.4857238,34.6865954 49.9126259,34.6865954 C20.9237098,34.6865954 7.43824825,17.7580992 7.43824825,17.7580992 L7.43824825,7.46642748 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.8157378,3.98858015 L70.0091119,44.7945115 C70.5255629,45.1885954 70.8282168,45.8002137 70.8282168,46.4492137 L70.8282168,54.6299466 C70.8282168,55.1965267 70.4547483,55.6941985 69.9094301,55.8509313 C68.9004336,56.1409771 67.2500455,56.609374 65.9433566,56.9507634 C65.3822517,57.0975878 64.9907413,57.6020153 64.9907413,58.1807557 L64.9907413,63.148916",
    id: "Shape",
    stroke: "#FBF8FF",
    strokeWidth: 0.8268,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1528147,63.7785496 C59.1528147,63.7785496 65.8296923,62.7462748 70.8282168,61.1167939 L70.8282168,64.8405496 C70.8282168,64.8405496 65.6781399,66.7226947 59.1528147,67.4324962 L59.1528147,63.7785496 Z",
    id: "Shape",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.335664, 63.053435)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.324259091,
    y: 0.323779389,
    width: 25.7097902,
    height: 21.1679389,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9273671,10.6186489 C18.9273671,10.6186489 12.2996538,9.79490076 7.25196503,7.3601374 L7.25196503,11.0838931 C7.25196503,11.0838931 12.402042,13.5627939 18.9273671,14.2725954 L18.9273671,10.6186489 Z",
    id: "Shape",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5876294,72.4465954 C22.5876294,72.4465954 20.9034126,71.6886031 19.4176573,70.8337786 C18.7897972,70.4725725 18.4068566,69.8001527 18.4068566,69.0768397 L18.4068566,61.9770229 C18.4068566,61.4469237 18.1407378,60.9546565 17.6951014,60.6664122 C15.9355594,59.5287481 11.250965,56.3580611 7.47433217,52.5262137",
    id: "Shape",
    stroke: "#FBF8FF",
    strokeWidth: 0.8268,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.024476, 11.259542)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4492902,10.5997328 L35.4371119,10.5997328 C35.4086958,8.00463359 33.6671958,5.40863359 30.2130629,3.42245038 C23.2763811,-0.566580153 12.0651084,-0.586847328 5.17172727,3.37696183 C1.49387413,5.4919542 -0.210188811,8.31359542 0.0523216783,11.092 L0.0523216783,12.939916 L0.524118881,12.939916 C1.26744755,14.7103664 2.84205944,16.3916412 5.25020979,17.7765649 C12.1868916,21.7655954 23.3981643,21.7858626 30.2915455,17.8220534 C32.7127762,16.4299237 34.2756608,14.7306336 34.9883182,12.939916 L35.4488392,12.939916 L35.4488392,10.5997328 L35.4492902,10.5997328 Z",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3032727,20.162687 C23.4098916,24.1264962 12.1986189,24.106229 5.26193706,20.1171985 C-1.67474476,16.1281679 -1.70992657,9.68140458 5.18345455,5.71759542 C12.0768357,1.75378626 23.2881084,1.77405344 30.2247902,5.76308397 C37.161472,9.75166412 37.1966538,16.1988779 30.3032727,20.162687 Z",
    fill: "url(#linearGradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1377_",
    transform: "translate(31.573427, 0.000000)",
    fill: "#00E9FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1384_",
    cx: 0.598993007,
    cy: 15.5782519,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1383_",
    cx: 32.8183217,
    cy: 27.7268473,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1382_",
    cx: 19.4654685,
    cy: 16.8816565,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1381_",
    cx: 12.0114336,
    cy: 32.8557939,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1380_",
    cx: 31.5432063,
    cy: 7.55019847,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1379_",
    cx: 4.34991608,
    cy: 0.766549618,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1378_",
    cx: 10.8761434,
    cy: 23.7378168,
    rx: 1,
    ry: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_7",
    transform: "translate(284.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "Shape",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.454545)",
    fill: "url(#linearGradient-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2954271,6.44090909 C42.2954271,6.44090909 8.19105208,27.4418182 6.10510417,28.7590909 C6.01417708,28.8240909 5.91921875,28.885 5.82067708,28.9422727 C4.10873958,29.9359091 1.8893125,29.3704545 0.88821875,27.6468182 C0.710395833,27.3409091 -0.707708333,24.6859091 2.24316667,22.5963636 L2.24227083,22.5940909 C2.25033333,22.5895455 2.25794792,22.585 2.26601042,22.5804545 C2.36455208,22.5113636 2.46757292,22.4431818 2.57596875,22.375 C2.89040625,22.1781818 3.35489583,21.8895455 3.95241667,21.5181818 C5.13984375,20.7813636 38.5714479,0.190454545 38.5714479,0.190454545 C38.8160104,0.0468181818 40.0809271,-0.633181818 41.9469479,1.91590909 C43.3023437,3.76818182 43.0824167,5.92090909 42.2954271,6.44090909 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.9973125,5.26818182 C42.9973125,6.91227273 41.8528854,7.57409091 40.4410521,6.74727273 C39.0292187,5.92 37.8847917,3.91681818 37.8847917,2.27318182 C37.8847917,0.629090909 39.0292187,-0.0327272727 40.4410521,0.794090909 C41.8528854,1.62090909 42.9973125,3.62454545 42.9973125,5.26818182 Z",
    fill: "url(#linearGradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.854167, 5.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.145528125,
    y: 0.147681818,
    width: 23.7395833,
    height: 20.4545455,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.822917, 5.909091)",
    fillRule: "nonzero",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-12)",
    opacity: 0.6,
    cx: 10.5202188,
    cy: 1.77045455,
    rx: 1.32180208,
    ry: 1.34136364
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-13)",
    opacity: 0.4,
    cx: 6.54898958,
    cy: 4.37454545,
    rx: 1.32180208,
    ry: 1.34136364
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-14)",
    opacity: 0.2,
    cx: 1.72134375,
    cy: 7.15136364,
    rx: 1.32180208,
    ry: 1.34136364
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero",
    opacity: 0.8,
    cx: 29.9253125,
    cy: 10.5404545,
    rx: 1.32180208,
    ry: 1.34136364
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(205.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-16)",
    points: "36.6607051 135.540383 74.9457692 135.540383 139.969936 105.231683 62.0725 66.2113531"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1433_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1441_",
    transform: "translate(0.000000, 71.815182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1442_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.96,54.38833 L36.9070513,64.0434323 C36.9070513,64.0434323 37.4710897,64.2763828 39.5935256,63.332462 L96.1633974,31.719868 C97.4458333,31.0030627 99.7966667,29.3306667 99.7841026,27.9024422 L99.8105769,23.0894785 C99.8105769,23.0894785 99.484359,19.7594983 96.6444231,17.584396 L36.96,54.38833 Z",
    id: "XMLID_1445_",
    fill: "url(#linearGradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9973077,63.7584158 L2.06320513,45.528132 C0.884871795,44.8759604 0.157948718,43.6667723 0.1575,42.3570429 L0.152564103,36.2662178 C0.152564103,36.2662178 0.152564103,33.5726997 2.87,31.8572145 L36.96,54.3878812 L36.9070513,64.0429835 C36.54,64.3459538 34.9973077,63.7584158 34.9973077,63.7584158 Z",
    id: "XMLID_1444_",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3592949,1.29446865 L96.6444231,17.5839472 C98.6735256,18.7127921 98.6735256,21.5346799 96.6444231,22.6630759 L41.6966667,53.2262706 C38.7445513,54.8681452 35.1072436,54.8681452 32.1551282,53.2262706 L2.87,36.9367921 C0.840897436,35.8079472 0.840897436,32.9860594 2.87,31.8576634 L57.8177564,1.29446865 C60.7698718,-0.347405941 64.4071795,-0.347405941 67.3592949,1.29446865 Z",
    id: "XMLID_1443_",
    fill: "url(#linearGradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1434_",
    transform: "translate(7.628205, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7392308,11.1183366 L51.2983333,32.4469967 L57.0917308,35.5642244 C57.0917308,35.5642244 60.1596154,16.3280792 58.8879487,14.8985083 C57.6167308,13.4689373 55.6760256,9.59854785 50.7392308,11.1183366 Z",
    id: "XMLID_1440_",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0751923,42.0118812 L46.34,29.7790627 C46.34,29.7790627 24.5022436,25.2165545 6.68365385,58.9539802 C-7.64391026,86.0812673 6.68365385,102.972198 6.68365385,102.972198 L27.8294872,114.757967 L69.0751923,42.0118812 Z",
    id: "XMLID_1439_",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1550641,49.4227591 L20.7208974,46.0869439 L20.7208974,33.6117492 C20.7208974,33.6117492 21.5003205,4.35065347 47.8728205,0.344264026 C47.8728205,0.344264026 55.6675,0.994191419 58.8879487,6.19091749 C58.8879487,6.19091749 39.056859,10.7404092 34.6957692,17.6274851 C30.3346795,24.5150099 27.1550641,49.4227591 27.1550641,49.4227591 Z",
    id: "XMLID_1438_",
    fill: "url(#linearGradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8997436,66.7320132 C15.8787821,87.0462838 16.8928846,108.914455 29.1648718,115.576211 C41.436859,122.237967 60.319359,111.17035 71.3403205,90.8560792 C82.3612821,70.5418086 81.3471795,48.673637 69.0751923,42.0118812 C56.8032051,35.3501254 37.9207051,46.4177426 26.8997436,66.7320132 Z",
    id: "XMLID_1437_",
    fill: "url(#linearGradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7465385,46.0407129 L27.1550641,49.4227591 L27.1550641,32.2055182 C27.926859,24.6783894 33.4528205,13.7292673 44.3674359,7.3130297 C57.9837821,-0.691221122 63.0314103,9.38759076 63.0314103,15.6103762 C63.0314103,21.8331617 63.0314103,38.7604488 63.0314103,38.7604488 L57.0917308,35.5646733 L57.225,17.0628383 C57.225,17.0628383 54.9437179,7.93557756 46.4414103,12.2916172 C37.9386538,16.6476568 32.6303205,29.2229439 32.599359,30.5986535 C32.5683974,31.974363 32.7465385,46.0407129 32.7465385,46.0407129 Z",
    id: "XMLID_1436_",
    fill: "url(#linearGradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0930128,75.8651089 C45.0930128,75.8651089 38.7746154,70.3681056 48.3919872,63.4967393 C48.3919872,63.4967393 58.6824359,60.3422574 51.9790385,72.1652805 L54.9679487,91.1348119 L42.4383974,98.3113927 L45.0930128,75.8651089 Z",
    id: "XMLID_1435_",
    fill: "url(#linearGradient-25)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-26)",
    fillRule: "nonzero",
    points: "54.2221795 124.686416 85.9003205 106.391947 85.9003205 103.014838 54.2221795 121.309307"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.269231, 100.541254)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.322583333,
    y: 0.322674587,
    width: 20.6410256,
    height: 21.5445545,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-27)",
    fillRule: "nonzero",
    points: "7.28089744 14.6947327 13.7083333 10.9935578 13.7083333 7.616 7.28089744 11.3176238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_8",
    transform: "translate(0.000000, 139.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,57.7523846 L77.0737526,11.1279692 C77.0737526,11.1279692 80.8495677,9.03327692 86.4963958,9.89123077 C86.4963958,9.89123077 81.2811667,4.27281538 76.9971641,5.50330769 C72.713612,6.73424615 0,51.1618 0,51.1618 L0,57.7523846 Z",
    fill: "url(#linearGradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.024154,54.8086615 C168.428115,54.8086615 167.823966,54.6627692 167.266221,54.3558154 L84.8641589,8.99267692 C80.8599297,6.78823077 75.9406927,6.88103077 72.0256667,9.23493846 C54.5197786,19.7632769 10.2889948,46.5026154 0,52.6979077 L0,44.2968308 C12.8763359,36.5453538 59.1583411,8.57507692 68.2633672,3.09943077 C74.3994609,-0.590707692 82.1096745,-0.7366 88.3858802,2.71886154 L170.788393,48.082 C172.538216,49.0448 173.167594,51.2305077 172.19537,52.9629231 C171.532654,54.143 170.297326,54.8086615 169.024154,54.8086615 Z",
    fill: "url(#linearGradient-29)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(84.697917, 5.353846)",
    fill: "#E2FEFF",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.1855365,49.503 C86.5792917,49.503 86.9626849,49.3022308 87.1766823,48.9417385 C87.4970026,48.4001077 87.3131901,47.7036615 86.7671589,47.3864462 L1.94039323,0.305169231 C1.39391146,-0.0107076923 0.690197917,0.169538462 0.369877604,0.710723077 C0.0495572917,1.25235385 0.233369792,1.9488 0.779401042,2.26601538 L85.6057161,49.3472923 C85.7881771,49.4530308 85.9882083,49.503 86.1855365,49.503 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(32.437500, 4.907692)",
    fill: "#E2FEFF",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4358099,22.8658308 C1.04250521,22.8658308 0.658661458,22.6650615 0.444664062,22.3041231 C0.12434375,21.7624923 0.30815625,21.0660462 0.8541875,20.7488308 L34.6139661,0.348 C35.1604479,0.0321230769 35.8641615,0.212369231 36.1844818,0.753553846 C36.5048021,1.29518462 36.3209896,1.99163077 35.7749583,2.30884615 L2.01517969,22.7096769 C1.83271875,22.8158615 1.6326875,22.8658308 1.4358099,22.8658308 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.015625, 12.046154)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-30)",
    opacity: 0.6,
    cx: 2.03590365,
    cy: 1.94032308,
    rx: 1.60295313,
    ry: 1.58741538
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-31)",
    opacity: 0.4,
    cx: 6.99118229,
    cy: 4.7966,
    rx: 1.60295313,
    ry: 1.58741538
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-32)",
    opacity: 0.2,
    cx: 12.9930208,
    cy: 7.80858462,
    rx: 1.60295313,
    ry: 1.58741538
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-33)",
    opacity: 0.8,
    cx: 97.4161198,
    cy: 11.6669231,
    rx: 1.60295313,
    ry: 1.58741538
  }))), /*#__PURE__*/React.createElement("g", {
    id: "server_3",
    transform: "translate(127.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-34)",
    fillRule: "nonzero",
    points: "43.5389881 177.350373 81.8508011 177.350373 146.920848 147.054999 68.9685376 108.051825"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1388_",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1392_",
    transform: "translate(41.310894, 25.572910)",
    fill: "url(#linearGradient-35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22809409,25.8003741 L0.145935224,151.308178 L0.145935224,151.308178 C1.43196132,152.066841 3.02781911,152.072225 4.31833552,151.321637 L46.6135065,126.724984 C47.8088283,126.030029 48.5438927,124.752281 48.5438927,123.370447 L48.5438927,0.0915240984 L2.22809409,25.8003741 Z",
    id: "XMLID_1393_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1390_",
    transform: "translate(0.000000, 26.918852)",
    fill: "url(#linearGradient-36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.156262947,0.134594262 L0.156262947,123.373587 C0.156262947,124.746449 0.882346813,126.017019 2.06509567,126.715563 L41.5232859,150.001716 C42.4141643,150.527531 43.5389881,149.885965 43.5389881,148.852281 L43.5389881,23.1632239 L0.156262947,0.134594262 Z",
    id: "XMLID_1391_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.801072119,28.3128004 L41.0329436,52.1108605 C42.8497248,53.18582 45.107455,53.1903065 46.9287266,52.1234227 L88.9746851,27.4931213 C90.1659656,26.7954744 90.143514,25.0672841 88.9347213,24.4005938 L46.3952772,0.931392295 C44.5443696,-0.0897295082 42.2848433,-0.0251242623 40.4954529,1.09963512 L0.77053798,26.0713573 C-0.0615173096,26.5949289 -0.0449031457,27.8125584 0.801072119,28.3128004 Z",
    id: "XMLID_1389_",
    fill: "url(#linearGradient-37)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.9353648,159.910994 L61.4149304,159.634179 C63.1145145,158.653884 64.492592,156.023463 64.492592,153.759139 L64.492592,52.9489341 C64.492592,50.68461 63.1145145,49.6437477 61.4149304,50.6244912 L60.9353648,50.9013068 C59.2357808,51.8816016 57.8577032,54.5120222 57.8577032,56.7763463 L57.8577032,157.586551 C57.8577032,159.850876 59.2357808,160.891289 60.9353648,159.910994 Z",
    id: "Shape",
    fill: "url(#linearGradient-38)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.638618, 111.713238)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.322763811,
    y: 0.322532717,
    width: 18.8593212,
    height: 19.7404918,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39195584,11.1744643 C7.39195584,12.5325204 8.3519851,13.0794218 9.53653008,12.3961316 C10.7210751,11.7128414 11.6811043,10.0582292 11.6811043,8.70017311 C11.6811043,7.34211701 10.7210751,6.79521566 9.53653008,7.47850586 C8.3519851,8.16179607 7.39195584,9.8164082 7.39195584,11.1744643 Z",
    id: "Shape",
    fill: "url(#linearGradient-39)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.0305734,142.343751 C59.0305734,143.701807 59.9906026,144.248709 61.1751476,143.565419 C62.3596926,142.882128 63.3197219,141.227516 63.3197219,139.86946 C63.3197219,138.511404 62.3596926,137.964503 61.1751476,138.647793 C59.9906026,139.331083 59.0305734,140.985695 59.0305734,142.343751 Z",
    id: "Shape",
    fill: "url(#linearGradient-40)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3273693,107.417437 L61.4746516,107.332643 C61.9955281,107.032049 62.4180667,106.22583 62.4180667,105.531772 L62.4180667,73.0676358 C62.4180667,72.3735781 61.9955281,72.0545897 61.4746516,72.3551835 L61.3278183,72.4399779 C60.8069418,72.7405718 60.3844029,73.5467914 60.3844029,74.2408491 L60.3844029,106.704985 C60.3839542,107.399043 60.8064928,107.718031 61.3273693,107.417437 Z",
    id: "Shape",
    fill: "url(#linearGradient-41)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9788445,153.537507 L72.4584101,153.260692 C74.1579941,152.280397 75.5360717,149.649976 75.5360717,147.385652 L75.5360717,46.5754472 C75.5360717,44.311123 74.1579941,43.2702607 72.4584101,44.2510043 L71.9788445,44.5278198 C70.2792604,45.5081147 68.9011829,48.1385352 68.9011829,50.4028593 L68.9011829,151.213065 C68.9016319,153.477389 70.2792604,154.518251 71.9788445,153.537507 Z",
    id: "Shape",
    fill: "url(#linearGradient-42)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.074053,126.389845 C70.074053,127.747901 71.0340823,128.294802 72.2186273,127.611512 C73.4031723,126.928222 74.3632015,125.27361 74.3632015,123.915554 C74.3632015,122.557497 73.4031723,122.010596 72.2186273,122.693886 C71.0345313,123.377176 70.074053,125.031789 70.074053,126.389845 Z",
    id: "Shape",
    fill: "url(#linearGradient-43)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.864404, 134.594262)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.322763811,
    y: 0.322532717,
    width: 18.4102897,
    height: 19.7404918,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20964907,11.2516317 C7.20964907,12.6096878 8.16967833,13.1565891 9.35422331,12.4732989 C10.5387683,11.7900087 11.4987975,10.1353966 11.4987975,8.77734049 C11.4987975,7.41928439 10.5387683,6.87238303 9.35422331,7.55567324 C8.17012736,8.2385148 7.20964907,9.89357557 7.20964907,11.2516317 Z",
    id: "Shape",
    fill: "url(#linearGradient-44)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.371298,101.043951 L72.5185803,100.959156 C73.0394568,100.658562 73.4619954,99.8523427 73.4619954,99.1582849 L73.4619954,66.6941489 C73.4619954,66.0000911 73.0394568,65.6811027 72.5185803,65.9816966 L72.371298,66.0664909 C71.8504215,66.3670848 71.4278829,67.1733044 71.4278829,67.8673622 L71.4278829,100.331498 C71.4278829,101.025556 71.8499725,101.344544 72.371298,101.043951 Z",
    id: "Shape",
    fill: "url(#linearGradient-45)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8547868,122.06892 L82.4507071,126.340045 C81.2877156,127.010773 79.8342008,126.172251 79.8342008,124.830795 L79.8342008,68.2352532 C79.8342008,67.0467858 80.4686822,65.9489453 81.4987604,65.3544873 L89.8543378,60.5346668",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.155813916,58.4731313 L41.1595704,81.1549564 C42.6359859,81.9714949 44.4330098,81.9557923 45.8946072,81.1123349 L51.8945655,77.6510191 C52.8101406,77.1229609 53.5591251,77.5550085 53.5591251,78.6111248 L53.5591251,135.208012 C53.5591251,136.868008 52.3817646,138.905765 50.9426188,139.735763 L45.9395103,142.621913 C44.4554613,143.477932 42.6252091,143.472548 41.1460995,142.607107 L0.155813916,118.626448",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0873
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.597334, 95.113279)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23663263,9.00570209 L1.11359801,9.0765884 C0.677139437,9.32827967 0.323302649,9.06088574 0.323302649,8.47988717 L0.323302649,1.88387102 C0.323302649,1.30242381 0.677139437,0.627209262 1.11359801,0.375517992 L1.23663263,0.30463168 C1.67309121,0.0529404098 2.026928,0.319885697 2.026928,0.90133291 L2.026928,7.49690041 C2.02647897,8.07834762 1.67264218,8.75356217 1.23663263,9.00570209 Z",
    fill: "url(#linearGradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23663263,19.4098386 L1.11359801,19.4807249 C0.677139437,19.7324161 0.323302649,19.4654709 0.323302649,18.8840236 L0.323302649,12.2884561 C0.323302649,11.7070089 0.677139437,11.0317944 1.11359801,10.7801031 L1.23663263,10.7092168 C1.67309121,10.4575255 2.026928,10.7244708 2.026928,11.305918 L2.026928,17.9014855 C2.02647897,18.4829327 1.67264218,19.1581473 1.23663263,19.4098386 Z",
    fill: "url(#linearGradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23663263,29.8144237 L1.11359801,29.88531 C0.677139437,30.1370013 0.323302649,29.870056 0.323302649,29.2886088 L0.323302649,22.6930413 C0.323302649,22.1115941 0.677139437,21.4363795 1.11359801,21.1846882 L1.23663263,21.1138019 C1.67309121,20.8621107 2.026928,21.1290559 2.026928,21.7105032 L2.026928,28.3065193 C2.02647897,28.8875179 1.67264218,29.5627324 1.23663263,29.8144237 Z",
    fill: "url(#linearGradient-48)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.417914, 79.410615)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31251895,8.83342143 L1.18948433,8.90430775 C0.753025753,9.15599902 0.399188965,8.88905373 0.399188965,8.30760652 L0.399188965,1.71203902 C0.399188965,1.1305918 0.753025753,0.455377254 1.18948433,0.203685984 L1.31251895,0.132799672 C1.74897752,-0.118891598 2.10281431,0.148053689 2.10281431,0.729500902 L2.10281431,7.32551705 C2.10281431,7.90651561 1.74897752,8.58173016 1.31251895,8.83342143 Z",
    fill: "url(#linearGradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31251895,19.2380066 L1.18948433,19.3088929 C0.753025753,19.5605841 0.399188965,19.2936389 0.399188965,18.7121916 L0.399188965,12.1166241 C0.399188965,11.5351769 0.753025753,10.8599624 1.18948433,10.6082711 L1.31251895,10.5373848 C1.74897752,10.2856935 2.10281431,10.5530875 2.10281431,11.134086 L2.10281431,17.7301022 C2.10281431,18.3111007 1.74897752,18.9863153 1.31251895,19.2380066 Z",
    fill: "url(#linearGradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31251895,29.6425917 L1.18948433,29.713478 C0.753025753,29.9651693 0.399188965,29.6977753 0.399188965,29.1167768 L0.399188965,22.5207606 C0.399188965,21.9393134 0.753025753,21.2640989 1.18948433,21.0124076 L1.31251895,20.9415213 C1.74897752,20.68983 2.10281431,20.9567753 2.10281431,21.5382225 L2.10281431,28.13379 C2.10281431,28.7156859 1.74897752,29.3909004 1.31251895,29.6425917 Z",
    fill: "url(#linearGradient-51)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.4149304,50.6240426 L61.4149304,45.3210286 C61.4149304,44.295869 60.8154734,43.3649254 59.881039,42.9400561 L54.5743852,40.5276783",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3219045,44.5017982 L72.3219045,39.1987843 C72.3219045,38.1736247 71.7224475,37.242681 70.7880131,36.8178118 L65.4813593,34.405434",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.021912, 6.281066)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1385_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8390106,38.6962991 L61.7777478,22.5795334 C62.9137974,21.9240594 62.436028,17.9817934 62.2838063,17.7628534 L31.2777352,1.11937561 L0.0973260843,18.2415604 C0.0973260843,18.2415604 0.062864404,22.0425023 1.19936302,22.6979764 L28.9324439,38.6958504 C30.4506192,39.5720591 32.3212843,39.5720591 33.8390106,38.6962991 Z",
    id: "XMLID_1387_",
    fill: "url(#linearGradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5799194,35.8931492 L61.5186567,19.7763836 C62.6547063,19.1209095 62.6547063,17.4824487 61.5186567,16.8269747 L33.3069083,0.55273377 C32.0850937,-0.152091516 30.5799403,-0.152091516 29.3581257,0.55273377 L0.940720902,16.9454176 C-0.195328684,17.6008917 -0.195328684,19.2393525 0.940720902,19.8948266 L28.6738017,35.8927006 C30.1915281,36.7689092 32.0617441,36.7689092 33.5799194,35.8931492 Z",
    id: "XMLID_1386_",
    fill: "url(#linearGradient-53)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.818038, 7.178361)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-54)",
    points: "21.7838631 1.54917996 2.3295752 12.7716495 0.28962529 11.594847 19.7439132 0.372377459"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-55)",
    points: "27.2589036 4.82565295 7.80461575 16.0476739 5.76421681 14.8708714 25.2189537 3.6484018"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-56)",
    points: "32.6867959 7.90427238 13.232059 19.126742 11.1921091 17.9494908 30.6463969 6.72746988"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M59.0305734,152.219381 C59.0305734,153.577437 59.9906026,154.124338 61.1751476,153.441048 C62.3596926,152.757758 63.3197219,151.103146 63.3197219,149.74509 C63.3197219,148.387034 62.3596926,147.840132 61.1751476,148.523423 C59.9906026,149.206264 59.0305734,150.861325 59.0305734,152.219381 Z",
    id: "Shape",
    fill: "url(#linearGradient-57)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0305734,132.763332 C59.0305734,134.121388 59.9906026,134.668289 61.1751476,133.984999 C62.3596926,133.301709 63.3197219,131.647097 63.3197219,130.28904 C63.3197219,128.930984 62.3596926,128.384083 61.1751476,129.067373 C59.9906026,129.750663 59.0305734,131.405276 59.0305734,132.763332 Z",
    id: "Shape",
    fill: "url(#linearGradient-58)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.074053,135.970264 C70.074053,137.32832 71.0340823,137.875222 72.2186273,137.191932 C73.4031723,136.508641 74.3632015,134.854029 74.3632015,133.495973 C74.3632015,132.137917 73.4031723,131.591016 72.2186273,132.274306 C71.0345313,132.957596 70.074053,134.612208 70.074053,135.970264 Z",
    id: "Shape",
    fill: "url(#linearGradient-59)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.074053,116.514664 C70.074053,117.87272 71.0340823,118.419621 72.2186273,117.736331 C73.4031723,117.053041 74.3632015,115.398429 74.3632015,114.040372 C74.3632015,112.682316 73.4031723,112.135415 72.2186273,112.818705 C71.0340823,113.501995 70.074053,115.156608 70.074053,116.514664 Z",
    id: "Shape",
    fill: "url(#linearGradient-60)",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "control_3",
    transform: "translate(85.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-61)",
    fillRule: "nonzero",
    points: "36.34245 79.359096 69.8643 79.8494915 125.78715 47.1525424 61.8903 9.90056497 36.5931 25.2072316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.08315,73.2908475 L83.8458,39.4372881 L67.7061,38.9559322 L20.44215,66.6124294 C19.40175,67.2384181 19.6281,68.5830508 20.46645,69.0386441 L28.08315,73.2908475 Z",
    id: "Shape",
    fill: "url(#linearGradient-62)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(17.100000, 35.254237)",
    fill: "#E2FEFF",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5381,27.9326554 C1.14525,27.9326554 0.76185,27.7292655 0.5481,27.3636158 C0.22815,26.8149153 0.41175,26.1093785 0.95715,25.7880226 L43.83405,0.542824859 C44.3799,0.222824859 45.0828,0.405423729 45.40275,0.953672316 C45.7227,1.5019209 45.5391,2.2079096 44.9937,2.52926554 L2.1168,27.7744633 C1.93455,27.8820339 1.73475,27.9326554 1.5381,27.9326554 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 20.790960)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-63)",
    points: "36.34245 58.6571751 0.42255 37.8282486 0.43425 21.1163842 36.3537 41.9457627"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-64)",
    points: "36.34245 58.6571751 72.2619 37.8282486 72.27315 21.1163842 36.3537 41.9457627"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-65)",
    points: "36.3537 41.9448588 0.43425 21.1163842 36.35325 0.287909605 72.27315 21.1163842"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-66)",
    points: "36.34785 58.5477966 0.4284 37.7184181 0.43965 21.0065537 36.3591 41.8359322"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-67)",
    points: "36.34785 58.5477966 72.26775 37.7184181 72.279 21.0070056 36.3591 41.8359322"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-68)",
    points: "36.35955 41.8354802 0.43965 21.0065537 36.3591 0.178079096 72.279 21.0070056"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.18965,54.580339 L43.18965,50.3213559 C43.18965,49.1507345 43.80885,48.0687006 44.81595,47.4788701 L55.36395,41.3048588 C56.65275,40.5505085 57.44565,39.1647458 57.44565,37.6664407 L57.44565,29.6085876",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.54115,53.4160452 L65.49345,49.9656497 C65.49345,49.6040678 65.1042,49.3780791 64.79235,49.5588701 L52.94925,56.4135593 C52.60545,56.6128814 52.1757,56.3633898 52.1757,55.9642938 L52.1757,54.6567232 C52.1757,53.9887006 51.79005,53.3816949 51.18705,53.100565 L48.16935,51.6926554",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-69)",
    fillRule: "nonzero",
    points: "62.9973 56.8610169 68.08545 53.9105085 68.08545 51.1534463 62.9973 54.1039548"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.600000, 42.937853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58255,10.3764972 L2.58255,3.29084746 C2.58255,2.55141243 2.98575,1.87163842 3.63285,1.51954802 L6.3063,0.0646327684",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-70)",
    fillRule: "nonzero",
    points: "5.12685 14.2110734 0.03825 11.260565 0.03825 8.50350282 5.12685 11.4540113"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2403,67.4612429 L27.2403,74.3064407",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-71)",
    fillRule: "nonzero",
    points: "29.78415 69.3044068 24.696 66.3534463 24.696 63.5963842 29.78415 66.5473446"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-72)",
    fillRule: "nonzero",
    points: "36.35955 37.7279096 7.52355 21.0065537 36.3591 4.28564972 65.1951 21.0070056"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_6",
    transform: "translate(389.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "Shape",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient-73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02214583,6.37553846 C1.02214583,6.37553846 35.1265208,26.9887385 37.2124688,28.2816923 C37.3033958,28.3454923 37.3983542,28.4052769 37.4968958,28.4614923 C39.2088333,29.4367846 41.4282604,28.8817692 42.4293542,27.1899538 C42.6071771,26.8896923 44.0252813,24.2837077 41.0744063,22.2327385 L41.07575,22.2305077 C41.0676875,22.2260462 41.0600729,22.2215846 41.0520104,22.2171231 C40.9534688,22.1493077 40.8504479,22.0823846 40.7420521,22.0154615 C40.4276146,21.8222769 39.963125,21.5389692 39.3656042,21.1749077 C38.1781771,20.4516923 4.74657292,0.240923077 4.74657292,0.240923077 C4.50201042,0.0999384615 3.23709375,-0.567507692 1.37107292,1.93452308 C0.0152291667,3.75215385 0.235604167,5.86513846 1.02214583,6.37553846 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.320260417,4.77875385 C0.320260417,6.39249231 1.4646875,7.04209231 2.87652083,6.23053846 C4.28835417,5.41853846 5.43278125,3.45233846 5.43278125,1.83904615 C5.43278125,0.225753846 4.28835417,-0.424292308 2.87652083,0.387261538 C1.4646875,1.19881538 0.320260417,3.16501538 0.320260417,4.77875385 Z",
    fill: "url(#linearGradient-74)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.927083, 1.338462)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.145528125,
    y: 0.144955385,
    width: 23.2916667,
    height: 20.0769231,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAuCAYAAACI91EoAAAABGdBTUEAALGOfPtRkwAAC3xJREFUaAXtmcmPXFcVxr9736vqandXT+72FFsZcJzYAZIIJIZkYYcVG7xAyZ4/ACUL72DFmghEYBEkFpFA7LyIEBtEuhVhglAWiQJJMCHO6KQ9tru7uqb37uV3bnXhtrvKY8di4dd69Ya6777zne+c75xbLd3d7nrgrgfuemDLPRCj09D9MN9t+RtvekJ3w08YELYX2Q8MfegN/Vh7dUJPM2Ih6sZnHzrjrXxx/dcm0+YBc1gf6XduguOo7hn6rn1SnFIf3CxPX/8VQye7xS/yaz6HSS8C54Ae00nJfV9P6QNtd6vrD32qf6qtVbdLD8VtmuLu61qEqY/1vo6pRiDOuhMx3nFgfiiodUDP6Bl9qik3otfcadVcXVV8f8p19Laf1E4/q0PO67yfAtwKtHhl7j3V3ZuMPcbkT+AMxTuba8NjI867eRgyQAWALqjhtmkW1g64JYw/o8/VTbGVYXpb2wm7hqbjrCbjv/Sm6roQM30l7tSuOx6Og5lKLNUJucuAMo0ByvsPdcYt66KraM5HjQA4+qpymPO+UMM39bHfDltNVRJrizD1lh6DtVmd5fxwUs4vlrnBTK2z9BagpgAwjjEdwKxIOKECuNy1VIOhS4Ri15Uai6PKYldF7LCPqhObasYd+hL3pmKLXFvTXr7bpb6QfJncexqgCzC81WIyBFR0P0LpHtQkYTeH4o0DbA/eb8CM/EhiYs2NATBXphXlqmBcqZIQLBGNAjDdOCmfgE4D7D/wNKp9AH1XF3Uv43YngE/imlQAthDcwPCb50UTugAtF3UfLx/H6BqhZiCm5BGNjPAbI+xGcUrpyCquPXvmdsDiOONqCMoI6tfVqF/VqjenmKDkuo/wPcezS+4xnnuV/Vnedzk0b796b2aKYHidcPmrdgEgd7uR8BV9RK5UYcX5gOEdtTyShoFjqYHgHg5YQzgqsQY7gZajCmNO2wm5S9xvwGIljquFe3bHNYS/rTVC9F5Ctc4Y2b5lzA1kaoWAUiqwOzn2SlmhDvVpSeQMOVTijAIT1zi2CMkGoVmQXw7gnmsTjdyXCMcaLJXKM69GtqpK1tJKFpX5tqp+VIu8/12/pBWYkzNR+f1m5qwtw44b3wYxRSicZfJXYaoOU9+EqbO8fAaGVnwXYy3copoYS5AhFKggjBlbbf5KgDMA79vkBX81AjiDmSrjnPLYVoCtEHONhwktwVIHMSmQ/ns4rzPubynvTuo1HdKh+Gs9TOt1hNlurPXaDIpHaQLcC3oBUFMAOuCq2m8q52GJkMs4bwKsIIdMtmuAKMmhGoZLTdgz40uCLhCyCAZ3BfgqINBHwlIaQUB89HIhAshpLJCH1LVqXEZFp7WKsJxCWMYZuzue0h8B5wH3JOCu33oNBGW15FlUapGuwFOfpGUUr4uBIxwrGB1hrRdqBqzFdU54UrNgLTrLMR5CQDKeMRHp8djh6GCop5Qx+ATUhSAf4Dqp5yqgrSxUtEJuhnhGbRj8CHCPU8jviz/FQSeuo5QDQTE/3YT0FgbR0blztEBIAqqWYfBFgEXX4JyAgyEPKGuPArnWgsFayrmA9AON8V1zBHAs53Kyg5EKobSXWFAI21WGHPYKmOM8hSdOCm1YLDUdWrA4QS0MHMlygB0F2MvmoYHb4Nu8yno2690seUkoN8dOI8t5KwFcRpIzgIwSol11AFACJiIQFUJUhKrdAwHHADhs4YPOMAHJDQAGt2HAE4KOUJQxB2st7nVChTq3phFA5nYeZjQXmvp3vKA3ATYJe1PxiDtyE6Bs6Aa22lzeC6BR9iV9TP0p3SUAmdKNUatMuUoUr4OqBUCQK5kBQgVRPawmFwFsJQFHRMun3htgpQfSWMsBV+BOF3BWIPvYa+UY1BVqh/Pca2oxdMi/7+r++BO6y5exMvnLZtuwDWbKBmxg632MxmUJ2Gm94fZqp5ZRRiu49RRiy76F8RRfAAnZ7iLbjt4wA1TJuRGRwpHQs5JgOWefHjAoNi+DTRgKsBWDU1ZS6wjJakFOlsxXrqlZktthTHsBO5vCkNSArc0Qhq+nGJzWQgAiDCM9GyVZ+io9XIv26RN9iDoFdK6K+jnyoGJqhmF58r450baumZ6CH91jLr4nPJELmDZB6Z3DKawRnIQfyBQzamGB4vKMFY6cIj2CA0bjeSJlicm/Tt/4tfSGzR/DQdnYDcBQLNHOxEWdcGf1Lfq7T2DLtjpV6H48vA0TGrBnIhBAZ6nYUzQGoWYV2CjtPoCseGcwaUppuWbZVsHoYI6xHEP37c8Zk3jH06m4uMKYWSR+Vh+QAivxqO63wsywK9lKwZ1sG/ZhwDBqgd3ktMYq99t4LOhhFKnLi1YinUKsc6wS+ybDLbzeTODKEiZKyxFjgMdhESM49fyZ5GMRNjhCFDrYyT0c7QhbnxGi3Otm9C60aeYoWx0sg2AX5fkf7nPKzqDt2kz1n1j3RC8cH4YNY60Oa9b4ZpojEKVzgBEi4MiFSgpK6yysi4cVdrsyt3sTC7ixXsPbzOzWUwJnHSzfZuYcU0EEpIc65a7TDMvRoAn3GSr5nKzXV+o1bPL+dmOg+qONNaObzYrqMVa1BoxzgnAHCWzn1sBiCrCsYeoxY69BxPmzraeEPsXn5VCJXGcplsgvU1bGIT0wZM/YRxVmx4gVFqB2S/ar1qC8ujlQNtMVrPVExICJjr1J5a9qEtltcG5pTqcIOSxb6BIsv1L4wYhPBdpYsLwCsLGFsyy3GARL5CWALP9yrnmSjXuE/fW3y466/tgrRxhrEG8/h3V0HC08g5cN0AWArYY6ElwnRbxGSgCWdIIm0yX1rEAUCrKqAAX3Qmr5AYW9ZrNdm5x7owjR6VKorZOkirGf1mcIVE+inseiI1dala5uHVR6fCHaj5f76KS9XqG7b+P2mcCvTKEgHDPtQMWysq0CwcgLmloWzgYkAiwAzPYScAa4f+3TM04VjhVAZihrLaB+ACxx2ARK+n58NP0Ut99+Dti03Xz4bZwCV56IdM1phSsSd9SKMsvFN6y94rUPArbN3WnG1GByjYBCTgg1kwmTatvLxJJ1G7ZFvjOxpCHBAYRnWUnfB8K4oE7ZAnNcD2h/fIYu/i/pmSs/MGsLtp52bOgXX6KWPa79OshvHB3aK2tyL7Kk7yDNjayicU8+IdlFbtZTnkFnyWqlmkUNYWehioSnkIXJAtEhLJcJyQlapp3hKfIUkaDIbYZwe0z1/bE+cb8D6eobsHYPOkjJ5VfcC4yjm8fQbXg5h0srqj7SjcCUyXkXkJZCLDqSsqWyQH626PsyvghhmdDusNDMNRcfoY/5DXNawz1ou82cumrKJB6Kf6cw/wrTbZkQ6KqbABrVHkjpIiDm8TbC0WEvC5KfvMq6bXW7rMu6dITdgnNrkyqaKKc0XYwDai8itCc1vK/Q952MB5l74arX9y83c9f/5naPhOQT0HCMqr8P1l6nAa7xO+Es985TbxpaYp0V2HOWLraYNG2zxSQrKxSPc/rJHGZmQgMpn4HVFV2Ke7UY/6Bfxnf0TlxwCwOt3FqmNr5inbUpWLNlgrFGI8wa6RQKFsIOTSP3M7RQnZK6xt6FuYKOvJWYLDVeTqhe0szSmZ8ijwzQdgAdin/SQVgaDMhM+OKY2gjwf6zZovMlt6bvoIznEI8HdE4fwt4cDSorp/Xtc/63MsJqYEqn4zn6vIZeiQ/pEfUAKb5n4wYIRP/5rRGK/mzDjsZaaq+OEmY/QEQmEY8/I/Cz1r0hFhMsNFlqrm9L2kMQbouX9LYewu+/1aPxuH7OvyQOAuiH1wRkU9wZpvrWYr40T679zMDpORg7QGgO257XSf7X1QdznGELd9riYaYNuG/g4rzmkxxEfY/V/OEN+y/W73OPcYfZB8xxjVt3lqlhhpjxV2/XyJmrh969vuuB/yMP/BdP648RJhq+2gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.822917, 5.800000)",
    fillRule: "nonzero",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-75)",
    opacity: 0.6,
    cx: 10.0499063,
    cy: 7.10544615,
    rx: 1.32180208,
    ry: 1.3166
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-76)",
    opacity: 0.4,
    cx: 5.99357292,
    cy: 4.68550769,
    rx: 1.32180208,
    ry: 1.3166
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#linearGradient-77)",
    opacity: 0.2,
    cx: 1.40645833,
    cy: 1.57492308,
    rx: 1.32180208,
    ry: 1.3166
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-78)",
    fillRule: "nonzero",
    opacity: 0.8,
    cx: 24.3371042,
    cy: 16.6486769,
    rx: 1.32180208,
    ry: 1.3166
  }))), /*#__PURE__*/React.createElement("g", {
    id: "server_2",
    transform: "translate(419.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 26.973684)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-79)",
    fillRule: "nonzero",
    points: "43.8794902 177.747588 77.3449412 177.747588 134.183353 151.345296 66.0925294 117.353958"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1427_",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1431_",
    transform: "translate(41.490196, 25.625000)",
    fill: "url(#linearGradient-80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.38929412,25.7850439 L0.297647059,151.548498 L0.297647059,151.548498 C1.5892549,152.308706 3.19203922,152.314101 4.48815686,151.561985 L46.966902,126.91523 C48.1674118,126.21886 48.9056667,124.938509 48.9056667,123.55386 L48.9056667,0.0238267544 L2.38929412,25.7850439 Z",
    id: "XMLID_1432_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1429_",
    transform: "translate(0.000000, 26.973684)",
    fill: "url(#linearGradient-81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308470588,0.0669846491 L0.308470588,123.557007 C0.308470588,124.932664 1.03770588,126.205822 2.22558824,126.905789 L41.8550392,150.239375 C42.7497843,150.766261 43.8794902,150.123388 43.8794902,149.087599 L43.8794902,23.1425219 L0.308470588,0.0669846491 Z",
    id: "XMLID_1430_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.956078431,28.3025877 L41.3625686,52.1491228 C43.1872353,53.2262719 45.4547647,53.2307675 47.2839412,52.1617105 L89.5123922,27.481239 C90.7088431,26.7821711 90.6862941,25.0504605 89.4722549,24.3824123 L46.7481765,0.865405702 C44.8892353,-0.157796053 42.619902,-0.0930592105 40.8227451,1.03399123 L0.925411765,26.0565789 C0.089745098,26.5812171 0.106431373,27.8013268 0.956078431,28.3025877 Z",
    id: "XMLID_1428_",
    fill: "url(#linearGradient-82)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.411765, 67.434211)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1426_",
    fill: "url(#linearGradient-83)",
    points: "0.0202941176 21.8095724 33.5971373 2.48517544 33.5971373 0.449111842 0.0202941176 19.7735088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1425_",
    fill: "url(#linearGradient-84)",
    points: "0.0202941176 33.1888706 33.5971373 13.8644737 33.5971373 11.8284101 0.0202941176 31.152807"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1424_",
    fill: "url(#linearGradient-85)",
    points: "0.0202941176 44.5681689 33.5971373 25.2437719 33.5971373 23.2077083 0.0202941176 42.5321053"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1423_",
    fill: "url(#linearGradient-84)",
    points: "0.0202941176 55.9474671 33.5971373 36.6230702 33.5971373 34.5870066 0.0202941176 53.9114035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1422_",
    fill: "url(#linearGradient-84)",
    points: "0.0202941176 67.3267654 33.5971373 48.0023684 33.5971373 45.9663048 0.0202941176 65.2907018"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7682745,47.8423246 L19.7682745,40.5302083 C19.7682745,39.8064145 20.148,39.1352193 20.769451,38.7602851 L65.6636471,11.2772478",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4109216,156.513004 L20.2769804,164.508004",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5178039,156.975603 L20.0361569,156.698224 C18.3291961,155.715932 16.9451373,153.080154 16.9451373,150.811217 L16.9451373,49.7956689 C16.9451373,47.5267325 18.3291961,46.48375 20.0361569,47.4664912 L20.5178039,47.7438706 C22.2247647,48.7261623 23.6088235,51.3619408 23.6088235,53.6308772 L23.6088235,154.646425 C23.6088235,156.915362 22.2247647,157.957895 20.5178039,156.975603 Z",
    id: "Shape",
    fill: "url(#linearGradient-86)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7557647,161.650592 L72.7557647,140.831853 C72.7557647,138.562917 71.3721569,137.519934 69.6647451,138.502675 L69.183098,138.780055 C67.4761373,139.762346 66.0920784,142.398125 66.0920784,144.667061 L66.0920784,165.51682",
    id: "Shape",
    fill: "url(#linearGradient-87)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2700392,146.62625 C67.2700392,147.987072 68.2342353,148.535088 69.4239216,147.850406 C70.6136078,147.165724 71.5778039,145.507741 71.5778039,144.146919 C71.5778039,142.786096 70.6136078,142.238081 69.4239216,142.922763 C68.2346863,143.606996 67.2700392,145.265428 67.2700392,146.62625 Z",
    id: "Shape",
    fill: "url(#linearGradient-88)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8287843,122.017708 L51.5678039,141.735921 C50.4002157,142.408015 48.9403922,141.567785 48.9403922,140.223596 L48.9403922,83.5132237 C48.9403922,82.3223355 49.5776275,81.2222588 50.6121765,80.6265899 L84.8731569,60.9083772 C86.0411961,60.2362829 87.5010196,61.0765132 87.5010196,62.4207018 L87.5010196,119.131524 C87.5005686,120.321963 86.8633333,121.422489 85.8287843,122.017708 Z",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0087
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.686275, 61.140351)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00856862745,8.15324561 C0.00856862745,8.96785088 0.585823529,9.2960307 1.29792157,8.8860307 C2.01001961,8.4760307 2.58727451,7.48339912 2.58727451,6.66879386 C2.58727451,5.8541886 2.01001961,5.52600877 1.29792157,5.93600877 C0.585823529,6.34600877 0.00856862745,7.33864035 0.00856862745,8.15324561 Z",
    fill: "url(#linearGradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98152941,5.31246711 C4.98152941,6.12707237 5.55878431,6.45525219 6.27088235,6.04525219 C6.98298039,5.63525219 7.56023529,4.64262061 7.56023529,3.82801535 C7.56023529,3.01341009 6.98298039,2.68523026 6.27088235,3.09523026 C5.55878431,3.50523026 4.98152941,4.49786184 4.98152941,5.31246711 Z",
    fill: "url(#linearGradient-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8187451,2.52743421 C9.8187451,3.34203947 10.396,3.6702193 11.108098,3.2602193 C11.8201961,2.8502193 12.397451,1.85758772 12.397451,1.04298246 C12.397451,0.228377193 11.8201961,-0.0998026316 11.108098,0.310197368 C10.396,0.720197368 9.8187451,1.71282895 9.8187451,2.52743421 Z",
    fill: "url(#linearGradient-91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1414_",
    transform: "translate(12.176471, 5.394737)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2519608,39.6122039 L62.3119608,23.4626096 C63.4529412,22.8058004 62.973098,18.8555044 62.8202157,18.6361184 L31.6795686,1.95873904 L0.363826941,19.1158004 C0.363826941,19.1158004 0.329215686,22.9244846 1.47064706,23.5812939 L29.324098,39.6117544 C30.8488627,40.4897478 32.7276471,40.4897478 34.2519608,39.6122039 Z",
    id: "XMLID_1421_",
    fill: "url(#linearGradient-92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9917451,36.8037939 L62.0517451,20.6541996 C63.1927255,19.9973904 63.1927255,18.3555921 62.0517451,17.6987829 L31.7341373,0.24995614 L1.20998039,17.8174671 C0.069,18.4742763 0.069,20.1160746 1.20998039,20.7728838 L29.0634314,36.8033443 C30.5886471,37.6813377 32.4669804,37.6813377 33.9917451,36.8037939 Z",
    id: "XMLID_1420_",
    fill: "url(#linearGradient-93)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1415_",
    transform: "translate(18.490196, 9.890351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1418_",
    transform: "translate(0.000000, 1.348684)",
    fill: "url(#linearGradient-94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9483137,12.7855263 C17.020451,15.6146162 9.00607843,15.5997807 4.04709804,12.7531579 C-0.911882353,9.90653509 -0.936686275,5.30527412 3.99072549,2.47663377 C8.91813725,-0.352006579 16.9329608,-0.337620614 21.8919412,2.50900219 C26.8509216,5.355625 26.8757255,9.95688596 21.9483137,12.7855263 Z",
    id: "XMLID_1419_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1416_",
    fill: "url(#linearGradient-95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9483137,12.6884211 C17.020451,15.517511 9.00607843,15.5026754 4.04709804,12.6560526 C-0.911882353,9.80942982 -0.936686275,5.20816886 3.99072549,2.37952851 C8.91858824,-0.449561404 16.9329608,-0.434725877 21.8919412,2.41189693 C26.8509216,5.25851974 26.8757255,9.85933114 21.9483137,12.6884211 Z",
    id: "XMLID_1417_"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.725490, 61.589912)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.324209804,
    y: 0.323189693,
    width: 16.2352941,
    height: 49.9013158,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAABwCAYAAACZ3blHAAAABGdBTUEAALGOfPtRkwAAD1tJREFUeAHtm91vHUcZxt/ZPV+248T5bpJCW0ijVlUhUntBW0GdIgQSUS/6B3BTpF5xEan3gAQXlYoQ4ob/oVIFEhJ3xCDKV1XUikBo1UYUN03SOK5jx8f2Obsz/J7Zs+fDx463IBASZ+zZj5nZeZ953o890r5jNikTBv4XGAiACPNULnar/wbOWuVnBcTm+btoz9mP7VW74nZ7dj8dF0II58oBbteh5YiRczVQsHEaIPcC5GG7bU/aV6ln+hPNcnWC+k6/xWzRzM1zPwKwIri7g+qxc5rJv2LfcM/bDf6uul/bX2g5Y5ltUe+4M3bY1mj5uXUstdUwY0ds1jZZxrWwxfUizzxlD9lrsGcVgO0OaoQds/M9MDP2jLsP4Ru26rYsB9QNtw9Q/4isbFodIAftAOCWwmW77T6wepi2P9iL9lA4DHsXwkXUimLvotGUucYLDJ1G0Hn7lvuJfc2mmOKKJe6ATbn9dp9r2kyybjcSF+8t2bKG85bRl7kpC8mmBVcH0D57ANkNoDfdHbvHvomkmq24S3bJLX4HBX93XLRadsaLZ83bWfdT+6G9xpgPqLMIXLYNNwe4pnUBseI6VnMN7j3TiPLM0A41tzwAMKxb3bftZNiwzXDUZsIyvvo09bq9CVcXmHUhGsh2aOOgotpkQ+bO9wCdBFCwZde220mNVWM5sGOAq9PukwwosGnr1BYxIqdOWRIA682aPtjHYdbu99hdBHac88uMZcE72tiYTc0zGA8D0FUYOu5O2oEI6I6tInwqaVstaVmeUllQPYGVhEesG1lyYgtQDgMXmE7etTam3QTcOsZvnGdwFsPGeMCW3GshPqgp+iVO2L+Dpee4kZe9jYcdses80YGhTQC1kqY10poltdx8DYXVsaO6WVpPLWkgrVGnDRuqJ1avB8tqqjPmUmc+3bClZA07nGLBhuoVMr5nGIbNj2lrFBRDXmVwaidZzzMut0fcKuqq2UGXwRAqS1ELwBo1D5jEfCOxvMGimwBr6oyNNVIL9dw69Lt617o17tPUmukdS5Kbtpis2HvYItDsLLZ7kavRMqK+efoepi6zkiO2ZAleBSsAWk+mmTizbpoDyJkDFA5maQ1gCSyhRnNch8zyHL34mtUzlJnBGmw3OHpU2kC1rXCMsZ3I1py9wkqOoqHh+DVgina9Pp4H1Bt2lFUcciu26LoYdxf6EZg2YYlu1OZZqG8ABLWlrcTSpmowzM0C957rjD7H2ByV5iw+hWWXHLaGBjH3227GrtklJqSMqHAACiL1PkvtDqtaJDDexrsa0BFgKsOmmoDLYCjHVhyCAqpjCO4FQICEFm0t7JZrJ3VKrQBPUKWrZSyqYx1WpTnn0MSsO2jvAw6rog6XIfVdxHNuo7o/uk8TjzMUuWbrrMYxUZoklqUeI9fKEYrApIEB6wwbAQaDXiB4XPAw2ZU+HDGMJp9YN4c1PLaZt2Fqww7RdsI+QkKHga8Q/Y+iqZKvIaaMV8e79pb9jXMLA1/VhG6DGDWDsQMEwdgrwIhNeJdvMI9Y6rFFiCJMAQTVOSoPYfAwhu057NDjhZFt5l1hvlXs6po7xUNEeBFFe1H6oOa5P6NIYo9g4I8RoQ+hxgTP80nH2lRsNrp3gnHTjD1xr4rwokp11HhPO8Aji1F9Ygr1saguKHPZKr847rEnsCuzOeo8tSh99V3k/g1g/dLuQ3XXidAb2FJTEZsa0ENKDRh8NHaABdRWAguaJ4GdwHJhJK4aFTmpLWMOeWxaZw5CC916Q5i9D1NrBNA1O8atEBRk9ZmiJZa23XJLDPZoo4tteYClvHhTojeehmCPbQVsS6+7gGoCjAgc75zIXOhdRy+lz7EQA0weo7/H2LfQgBZcs/txq0ch468Fmh6GMVBqBwhw5vhrocIGxuihOxMgxosxCVKklhoVrxgWPVK2ozCg4BmwvZCKJTmCjFE2WscBpjjPseRp+5BHD6KV52yeq7KMgWoACFuyVVtjNXUY24KlDMPkhRZV5OVSeg45htAAOKlPrJnCBe2OKB7PUjeeK4Z1ruGRgbk6LLLG3A1rExFl7FJeWcZAHeZ31KewK14T/G3yGL+QiC08wIQOYC5G8F4YEFsCEQECTAYjmwJs2R7Z0kJYZI4a1d20fWh/3abddYJoCaY8y0B3LcQk3Fa/nVg3lBOvmEC2LMOXHK+Vw0LQ4iKZYk79sCqwtAUWAklFG+NzFKdQk7h1WNoff8WPQtBkY0VIpQsVUcBLFlAlfrElNymB6IwsQHHoVZ3U5qkKqoRdwPBiZpjnNaDQJr5a/HLX23a07AhqmjGHhsZpkCbEvSUERIrWXHLGC9WmIREsvZzFZIzwvTb92qtxnWDoNcxiQw/vWsrl7zoAAaxRcUXqq3EtYXFOCaREO1ML9wIs9Qp0bGIhUjGvaG7jUz1JWoVeATuVPUCJeJWMaTVU00qh4iseBawHQL1AKnvoLoHRRuwoeos5CvM42J8nTtY/7AFK3aqbVCmwgFKsXlgKET0ovftCpUCITEZlM07APE5TLE5P7l52tKmdhguQvFGSo/ShswQOnhHwYrRUrlr0qU2/5bvcF2wPnhm9qgxKj2l23nnxrOuyqq+EKtFqL0txLbuUIcinJVKutHv5RKB6DAzL7M1cwivOmrScWItQ/SRlD5vaa6oSTCm0xKtz4SKaYaDCveYr+ssFVRv9Xxo1AVWV6AlTE6aqMlB13MSmJkxVZaDquIlNTZiqykDVcRObmjBVlYGq4yY2NWGqKgNVx01sasJUVQaqjpvY1ISpqgxUHTexqQlTVRmoOm5iUxOmqjJQddzEpv6fmCo/e1Rdczmu/DxS3t/9/C/YlL5Z63tLeSy/y5T3xWelQasAFc/ERyocKn4wkgjV4ktpcVV+Eio/pQ1gDD4VGZ/Uyk9wAjcYw82uZQ+m9OVXVROTCaV0g3hdtKi1uIofQaOQoqUYNdTPsxLV5agnsjh2t8MeoASEXAvS1hDWXyYfqvm87so22vtdyAmxXeOLMVJd0a8P3DUleZAMdbeyo/q0DpKt+kWr13R8aedq8N1ca5a4QmQUTnadxgxay0loLRcRm6RiEg/JeRgvOzLVZtzHQ2MlQrahicQSR6rOCYJUJVAM6WNy0Ve0l31Oiaj8DTggFS3me3IaK4NRY13RIhCinIIICHUosVSZGAUgmgVE6W4F3uJezygfkX8eYLwYVZsSCfTNvrRNmncsY6CUdtPmT2CwJc45q/QksBRMwA6fzyVUQBw5eI57JXJE2QJCm6cKcMFUAVBGIWBKsFRaCamDHJUyvr2Mqe8W+Z0f8NckG4gUkEACTlyyFl1M7mBL3/UFTqA0tzLKPPmd6ko4O+XwSqb6BDI+qy/ujlTwLaxJyRNkndllkqK2lzFQpDyGfbafRPc6E7UjsNJeBKBgRhmKug4IjxhJIE5INiUbKbZBbwSqMcoES6l1ElJrLITEPWSQ8xkORDO/vB3TwPIW6FLKnrLuj6H5DoyRokY+ilTXRIUiTCeSZLF7JifXLgDEunSIGBYogycxpsjDE0DpjLFScQrALnaprFnl/MOZ3QxkUvH4aOkzdY72H0QN30Q6acsAIuMsoDyQkIYXJxUoNGUeQDlVwEgaixGEBMd4zSMWSNNwpDsKlJhUlW0GOuWJU2TzBxY7R5bZg0Stq7YwhKsPSm0pnbP2e6V+kMB3CN23UKHMIUFdTmpg8hRhUVURDOoTgA6Bcouz0tQ7PCP2OtgdrCUZz+akckU7k9NgW6BNyTTTtowrSH3VREpZRrxvmhSrL6OqP9tlVnQ0OjB+wgRbyEh7hhwiO0X6myM2KHJjgDE5iGOhXgBHBgEnVh3gaoBKcnI8UaOP2fxTdosM//chYjhbq0j56QFc4DyHRZ2F0lOY+DJMtcn+m4GllLzbnJzclFV3tHLYiVmMmJBUKsOWTcnuHNdSqxeDXVgVQN0rmx7baoZN6/BQiw0aR+xz9iiOtRK+P6TAIfWdg8xvm/a+/IJtJkvRCBNCQk5qYo7nZDImah1hdaW2oh4PhTlq85ugU/rYJqrT2yOqEiCo0ndRGSpP8w4L0FykVbLAg+EtWwzkv8PUexwHCmSeQbmI+ZD1TPLpJjs5Om6T7FdvS6RFFjnDysgnr4f/nHTGQO6wUnGVTun08yHOVagvQVV5xrsS9SXYm++SDdvpsiDWkrO1JWvY8Vx7bNaw3TMwfK5It4pghpgqsP6I5i+w9yXFAGdZERP4zNrQ3mKSGoIGwmABVhKxRNZXTvXUsMU2AxiMLMJoiI6hTOuGZewO6WIOW3jfR0SpSwWgAS/xasTQ1SJ/0K4gbcI5wXtrxo5jmLd4y2bKrZNdEKiUlBUju4ImTCoxUHFRv7pyFuRYQBPb6ihGYYNeFfV5P40np4x5hx0iM/Ylu5+ZtpdRUIjVxi5tU9KuoNQ+TyrqA+GmbbLClMxDfIdWjB3PbKDsVKDICfbKWecFWMPd448eCcbTikDLthYWlsgTsKdTfh90ngCJjC+++4ZUJ4DRDnTRL4h6lvaXaPgV5xYp2lv2IUw0k1l2FimLHxthv8M05xwwDVjs0K8kU7GnvwCoAHVKkJ+Sk6DXTr7Ka0bePI0/rOCgT9qp8LgEbwM1YlMRmNiyBdz2TXvc1sIq+j9mJ6PH4HlsVsjzfdbK2DeT1Sztkq/eZe8D9Hi8MSUEZFTfLexPGftZzu8BAGUKwKFtr8P067wvFnZkKWKMQLYfcKWn7Fn3or2EBb/pHrRnyK1vAvdasp/NPcQzVHUTpmruDupsxERlgj3E6zcTHoa9BAAopKS8fPf5ZXub+yXC5Awx4wkkWHhBcrexpKZxpuJAbUn6GVuTHuKFfDb81n4DuANM/lnUMutXUQ2Z0jDQ5vWhSD8Doo3ISscaGSqmLcPIj7LDaBob0rvuRDiE2vYCtDuoCMzFvVIv44lftM+Ep1nZsl3FFn7HvioJOu5vYyMNO+KP4O6bdpvQcStvcu6wsWLNtlD5DZzk7/4jnpUNscPkrgxJrMrOTBV9ohZgR8MFrOwIbcejga7pDR1O8/uoYQcAYv5dYtkV2/CLxLWu3Uv7DN62n8D4J9T4iEJ8eBS1GXv8dlNZKVLnce8b7h2+Bso849kRFPdurLBrZDFuA9DurZ3K1WjMZ+zrxKT37IVo1uckUWzdtVQHVU4jnph6ngP7XQDY2yOk1l6Z5V3wGH8L3J/rHauAKZ//5KDKJ3Uu1rzzHBUYGZ5qcj1h4D/JwD8BufmqCRJqjhkAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39860784,42.7852083 L8.25068627,42.7002412 C7.72754902,42.3990351 7.30317647,41.5911732 7.30317647,40.8957018 L7.30317647,8.3654386 C7.30317647,7.66996711 7.72754902,7.35032895 8.25068627,7.65153509 L8.39815686,7.73650219 C8.92129412,8.03770833 9.34566703,8.84557018 9.34566703,9.54104167 L9.34566703,42.0713048 C9.34611765,42.7667763 8.9217451,43.0864145 8.39860784,42.7852083 Z",
    id: "Shape",
    fill: "url(#linearGradient-96)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.8119608,161.021656 L73.8119608,140.095921 C73.8119608,137.037555 71.9467059,135.631776 69.6458039,136.956184 L68.9963922,137.32977 C66.6954902,138.654178 64.8302353,142.206612 64.8302353,145.264978 L64.8302353,166.232971",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 0.5391
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.308470588,126.859934 L9.83227451,132.340987 C11.0003137,133.013081 12.4596863,132.172851 12.4596863,130.828662 L12.4596863,74.1178399 C12.4596863,72.9269518 11.822451,71.826875 10.787902,71.2312061 L0.308470588,65.1998904",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21360784,115.47659 L5.89611765,115.294068 C4.77137255,114.6467 3.8594902,112.910044 3.8594902,111.415252 L3.8594902,88.2983553 C3.8594902,86.8035636 4.77137255,86.1161842 5.89611765,86.7635526 L6.21360784,86.9460746 C7.33835294,87.593443 8.25023529,89.3300987 8.25023529,90.8248904 L8.25023529,113.941787 C8.25023529,115.437029 7.33835294,116.123958 6.21360784,115.47659 Z",
    id: "Shape",
    fill: "url(#linearGradient-97)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.823529, 138.015351)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.324209804,
    y: 0.323189693,
    width: 18.4901961,
    height: 19.7807018,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6073333,11.2529715 C11.6073333,12.6137939 10.6431373,13.1618092 9.45345098,12.4771272 C8.26376471,11.7924452 7.29956863,10.1344627 7.29956863,8.77364035 C7.29956863,7.41281798 8.26376471,6.86480263 9.45345098,7.54948465 C10.6431373,8.23371711 11.6073333,9.89214912 11.6073333,11.2529715 Z",
    id: "Shape",
    fill: "url(#linearGradient-98)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.4308627,129.772643 C22.4308627,131.133465 21.4666667,131.68148 20.2769804,130.996798 C19.0872941,130.312116 18.123098,128.654134 18.123098,127.293311 C18.123098,125.932489 19.0872941,125.384474 20.2769804,126.069156 C21.4666667,126.753838 22.4308627,128.41182 22.4308627,129.772643 Z",
    id: "Shape",
    fill: "url(#linearGradient-99)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4308627,139.372577 C22.4308627,140.733399 21.4666667,141.281414 20.2769804,140.596732 C19.0872941,139.91205 18.123098,138.254068 18.123098,136.893246 C18.123098,135.532423 19.0872941,134.984408 20.2769804,135.66909 C21.4666667,136.353772 22.4308627,138.011754 22.4308627,139.372577 Z",
    id: "Shape",
    fill: "url(#linearGradient-100)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(18.039216, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0761765,9.68355263 L38.2553137,7.66277412 L38.2548627,49.8024123 C38.2548627,49.8096053 38.2553137,49.8163487 38.2553137,49.8235417 L38.2553137,49.8365789 L38.2544118,49.8365789 C38.2553137,51.6892215 37.030451,53.537818 34.5757647,54.947193 C29.647902,57.7762829 21.6335294,57.7614474 16.674549,54.9148246 C14.0399216,53.4025 12.7983725,51.3947588 12.9517059,49.4211842 L13.0761765,9.68355263 Z",
    id: "XMLID_1376_",
    fill: "url(#linearGradient-101)",
    fillRule: "nonzero",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1374_",
    opacity: 0.2,
    transform: "translate(12.627451, 16.184211)",
    fill: "#F6F5FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4975,34.3235636 C0.4975,34.3235636 0.4765,33.7885855 0.4405,32.8521491 C0.4165,31.9157127 0.359,30.5782675 0.332,28.9728838 C0.3075,27.3675 0.253,25.4950768 0.242,23.4882346 C0.2295,21.4818421 0.216,19.3414803 0.203,17.2011184 C0.216,15.0607566 0.2295,12.9203947 0.242,10.9140022 C0.252,8.90760965 0.308,7.03473684 0.332,5.42935307 C0.3585,3.8239693 0.417,2.48652412 0.441,1.55008772 C0.4775,0.613651316 0.4985,0.0786732456 0.4985,0.0786732456 C0.4985,0.0786732456 0.5195,0.613651316 0.556,1.55008772 C0.58,2.48652412 0.6385,3.8239693 0.665,5.42935307 C0.689,7.03473684 0.745,8.90716009 0.755,10.9140022 C0.7675,12.9203947 0.7805,15.0607566 0.794,17.2011184 C0.7805,19.3414803 0.7675,21.4818421 0.7545,23.4882346 C0.743,25.4946272 0.6885,27.3675 0.6645,28.9728838 C0.6375,30.5782675 0.58,31.9157127 0.556,32.8521491 C0.518,33.7885855 0.4975,34.3235636 0.4975,34.3235636 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1372_",
    opacity: 0.2,
    transform: "translate(37.882353, 24.276316)",
    fill: "#F6F5FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.413,26.4166776 C0.413,26.4166776 0.392,26.0066776 0.3555,25.2891776 C0.3315,24.5716776 0.274,23.5466776 0.247,22.3166776 C0.2225,21.0866776 0.168,19.6516776 0.1565,18.1141776 C0.144,16.5766776 0.1305,14.9366776 0.1175,13.2966776 C0.1305,11.6566776 0.144,10.0166776 0.1565,8.47917763 C0.1665,6.94167763 0.2225,5.50667763 0.2465,4.27667763 C0.273,3.04667763 0.3315,2.02167763 0.3555,1.30417763 C0.392,0.586677632 0.413,0.176677632 0.413,0.176677632 C0.413,0.176677632 0.434,0.586677632 0.4705,1.30417763 C0.4945,2.02167763 0.553,3.04667763 0.5795,4.27667763 C0.6035,5.50667763 0.6595,6.94167763 0.6695,8.47917763 C0.682,10.0166776 0.695,11.6566776 0.7085,13.2966776 C0.695,14.9366776 0.682,16.5766776 0.669,18.1141776 C0.6575,19.6516776 0.603,21.0866776 0.579,22.3166776 C0.552,23.5466776 0.4945,24.5716776 0.4705,25.2891776 C0.434,26.0066776 0.413,26.4166776 0.413,26.4166776 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.9990784,8.70350877 L17.9990784,35.6965241",
    id: "XMLID_1371_",
    stroke: "url(#linearGradient-102)",
    strokeWidth: 2.3639,
    opacity: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3640392,20.6744298 L25.3640392,39.6625548",
    id: "XMLID_1370_",
    stroke: "url(#linearGradient-103)",
    strokeWidth: 2.3639,
    opacity: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2848824,0.107445175 L34.2848824,27.1004605",
    id: "XMLID_1369_",
    stroke: "url(#linearGradient-104)",
    strokeWidth: 2.3639,
    opacity: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1361_",
    transform: "translate(9.019608, 8.991228)",
    fill: "#00E9FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1368_",
    cx: 0.569588235,
    cy: 15.5714583,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1367_",
    cx: 32.7844706,
    cy: 27.6974781,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1366_",
    cx: 19.4336471,
    cy: 16.8720395,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1365_",
    cx: 11.9802941,
    cy: 32.8170833,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1364_",
    cx: 31.509098,
    cy: 7.55757675,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1363_",
    cx: 4.31994118,
    cy: 0.786282895,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1362_",
    cx: 10.8456275,
    cy: 23.7161623,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(107.333333, 129.024123)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0847843137,8.04804825 C0.0847843137,8.86265351 0.662039216,9.19083333 1.37413725,8.78083333 C2.08623529,8.37083333 2.6634902,7.37820175 2.6634902,6.56359649 C2.6634902,5.74899123 2.08623529,5.4208114 1.37413725,5.8308114 C0.662039216,6.2408114 0.0847843137,7.23344298 0.0847843137,8.04804825 Z",
    id: "Shape",
    fill: "url(#linearGradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05729412,5.20726974 C5.05729412,6.021875 5.63454902,6.35005482 6.34664706,5.94005482 C7.0587451,5.53005482 7.636,4.53742325 7.636,3.72281798 C7.636,2.90821272 7.0587451,2.58003289 6.34664706,2.99003289 C5.63454902,3.40003289 5.05729412,4.39266447 5.05729412,5.20726974 Z",
    id: "Shape",
    fill: "url(#linearGradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8945098,2.42223684 C9.8945098,3.23684211 10.4717647,3.56502193 11.1838627,3.15502193 C11.8959608,2.74502193 12.4732157,1.75239035 12.4732157,0.937785088 C12.4732157,0.123179825 11.8959608,-0.205 11.1838627,0.205 C10.4722157,0.615 9.8945098,1.60763158 9.8945098,2.42223684 Z",
    id: "Shape",
    fill: "url(#linearGradient-107)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.39164706,146.850581 C4.39164706,148.211404 3.42745098,148.759419 2.23776471,148.074737 C1.04807843,147.390055 0.0838823529,145.732072 0.0838823529,144.37125 C0.0838823529,143.010428 1.04807843,142.462412 2.23776471,143.147094 C3.42745098,143.831776 4.39164706,145.490208 4.39164706,146.850581 Z",
    id: "Shape",
    fill: "url(#linearGradient-108)",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_5_1_",
    transform: "translate(619.000000, 134.000000)",
    fillRule: "nonzero",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.572973,29.5920513 L47.5869369,11.0164744 C47.5869369,11.0164744 52.3094595,8.46685897 55.2837838,8.95910256 C55.2837838,8.95910256 50.3405405,4.61641026 44.6045045,6.36192308 C38.8684685,8.10698718 17.5734234,23.4782692 17.5734234,23.4782692 L17.5734234,29.5920513 L17.572973,29.5920513 Z",
    id: "Shape",
    fill: "url(#linearGradient-109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,33.7211538 L55.2837838,8.95910256 C51.2801802,6.74198718 46.3617117,6.83532051 42.4472973,9.20275641 C24.9436937,19.7916026 10.6563063,28.4388462 0.369369369,34.6697436 L0.369369369,26.2203846 C13.2436937,18.424359 29.581982,8.53910256 38.6855856,3.03153846 C44.8207207,-0.679807692 52.5297297,-0.826089744 58.804955,2.64878205 L100,25.4607051 L100,33.7211538 Z",
    id: "Shape",
    fill: "url(#linearGradient-110)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(9.459459, 4.038462)",
    fill: "#E2FEFF",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53693694,19.9338462 C1.14324324,19.9338462 0.75990991,19.7319231 0.545945946,19.3689103 C0.225675676,18.8241667 0.409459459,18.1237179 0.955405405,17.8046795 L29.7932432,0.166025641 C30.3396396,-0.151666667 31.0432432,0.0296153846 31.3635135,0.573910256 C31.6837838,1.11820513 31.5,1.81910256 30.9540541,2.13814103 L2.11621622,19.7767949 C1.93423423,19.883141 1.73423423,19.9338462 1.53693694,19.9338462 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "control_2",
    transform: "translate(547.000000, 84.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-111)",
    points: "46.597125 119.52806 80.0386447 119.52806 136.836411 93.2314925 68.7942796 59.3762687"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 36.716418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1490_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1494_",
    transform: "translate(0.000000, 25.522388)",
    fill: "url(#linearGradient-112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.597125,25.6692537 L48.6868257,56.8173134 L48.6868257,56.8173134 C47.3961414,57.5744776 45.7945033,57.5798507 44.4993125,56.8307463 L2.05094408,32.2826866 C0.851292763,31.5891045 0.113565789,30.3138806 0.113565789,28.9347761 L0.113565789,0.0111940299 L46.597125,25.6692537 Z",
    id: "XMLID_1495_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1492_",
    transform: "translate(46.417763, 26.865672)",
    fill: "url(#linearGradient-113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7192237,0.0546268657 L43.7192237,28.9383582 C43.7192237,30.3085075 42.9905099,31.5765672 41.803477,32.2737313 L2.20236513,55.5138806 C1.30825987,56.0386567 0.179361842,55.3983582 0.179361842,54.3667164 L0.179361842,23.0373134 L43.7192237,0.0546268657 Z",
    id: "XMLID_1493_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.4902928,28.1771642 L49.1126974,51.928209 C47.2893355,53.000597 45.0234276,53.0055224 43.1955592,51.9407463 L0.997305921,27.3591045 C-0.198289474,26.6628358 -0.175756579,24.9380597 1.03741447,24.2726866 L43.7309408,0.850298507 C45.5885526,-0.16880597 47.8562632,-0.104328358 49.6521349,1.01820896 L89.5209375,25.940597 C90.3560066,26.4626866 90.3393322,27.6774627 89.4902928,28.1771642 Z",
    id: "XMLID_1491_",
    fill: "url(#linearGradient-114)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.924342, 51.940299)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71521382,24.4701493 L3.07709211,24.2623881 C4.35966447,23.5267164 5.39978289,21.5525373 5.39978289,19.8532836 L5.39978289,2.12776119 C5.39978289,0.428507463 4.36011513,-0.352835821 3.07709211,0.383283582 L2.71521382,0.591044776 C1.43264145,1.32671642 0.392523026,3.30089552 0.392523026,5.00014925 L0.392523026,22.7256716 C0.392523026,24.4249254 1.43264145,25.2058209 2.71521382,24.4701493 Z",
    fill: "url(#linearGradient-115)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.351974, 4.477612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.444799342,2.65074627 C0.444799342,3.49835821 1.04732895,3.83955224 1.79046382,3.41328358 C2.53359868,2.98701493 3.13612829,1.95447761 3.13612829,1.10686567 C3.13612829,0.259253731 2.53359868,-0.0819402985 1.79046382,0.344328358 C1.04732895,0.770597015 0.444799342,1.80313433 0.444799342,2.65074627 Z",
    fill: "url(#linearGradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.444799342,8.81283582 C0.444799342,9.66044776 1.04732895,10.0016418 1.79046382,9.57537313 C2.53359868,9.14910448 3.13612829,8.11656716 3.13612829,7.26895522 C3.13612829,6.42134328 2.53359868,6.08014925 1.79046382,6.50641791 C1.04732895,6.93268657 0.444799342,7.96522388 0.444799342,8.81283582 Z",
    fill: "url(#linearGradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.444799342,14.7908955 C0.444799342,15.6385075 1.04732895,15.9797015 1.79046382,15.5534328 C2.53359868,15.1271642 3.13612829,14.0946269 3.13612829,13.2470149 C3.13612829,12.399403 2.53359868,12.058209 1.79046382,12.4844776 C1.04732895,12.9107463 0.444799342,13.9437313 0.444799342,14.7908955 Z",
    fill: "url(#linearGradient-118)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.210526, 47.462687)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6073026,29.2598507 L0.283914474,13.4744776 L0.283914474,5.66865672 C0.283914474,1.23179104 2.99912829,-0.807761194 6.34796711,1.11358209 L21.5427993,9.83014925 C24.8920888,11.7514925 27.606852,16.9056716 27.606852,21.3425373 L27.606852,29.2598507 L27.6073026,29.2598507 Z",
    fill: "url(#linearGradient-119)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.210526, 7.164179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49167763,3.64925373 C2.2348125,4.07552239 2.83734211,3.73432836 2.83734211,2.88671642 C2.83734211,2.03910448 2.2348125,1.00656716 1.49167763,0.580298507 C0.748542763,0.154029851 0.146012905,0.495223881 0.146012905,1.34283582 C0.1455625,2.19 0.748092105,3.22298507 1.49167763,3.64925373 Z",
    fill: "url(#linearGradient-120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89641776,6.74955224 C7.63955263,7.1758209 8.24208224,6.83462687 8.24208224,5.98701493 C8.24208224,5.13940299 7.63955263,4.10686567 6.89641776,3.68059701 C6.15328289,3.25432836 5.55075329,3.59552239 5.55075329,4.44313433 C5.55075329,5.29074627 6.15328289,6.32328358 6.89641776,6.74955224 Z",
    fill: "url(#linearGradient-121)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1471_",
    transform: "translate(59.036184, 38.059701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1481_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1489_",
    fill: "url(#linearGradient-122)",
    points: "0.325375 22.5089552 28.7398059 6.20910448 28.7398059 0.203731343 0.325375 16.5031343"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1488_",
    fill: "url(#linearGradient-123)",
    points: "1.30735855 20.6825373 3.46240461 19.4462687 3.46240461 15.7253731 1.30735855 16.9616418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1487_",
    fill: "url(#linearGradient-124)",
    points: "4.37318421 18.9237313 6.52868092 17.6874627 6.52868092 13.9665672 4.37318421 15.2028358"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1486_",
    fill: "url(#linearGradient-125)",
    points: "15.1966349 9.85970149 28.0070362 2.51104478 28.0070362 1.64552239 15.1966349 8.9941791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1485_",
    fill: "url(#linearGradient-126)",
    points: "17.7644836 11.2423881 28.0070362 5.36686567 28.0070362 4.50134328 17.7644836 10.3768657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8275263,13.7977612 C12.8275263,14.1232836 13.0587138,14.2544776 13.3444309,14.090597 C13.6296974,13.9267164 13.8613355,13.5304478 13.8613355,13.2049254 C13.8613355,12.879403 13.630148,12.748209 13.3444309,12.9120896 C13.0591645,13.0759701 12.8275263,13.4726866 12.8275263,13.7977612 Z",
    id: "XMLID_1484_",
    fill: "url(#linearGradient-127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8847401,14.9126866 C10.8847401,15.238209 11.1159276,15.369403 11.4016447,15.2055224 C11.6869112,15.0416418 11.9185493,14.6453731 11.9185493,14.3198507 C11.9185493,13.9943284 11.6873618,13.8631343 11.4016447,14.0270149 C11.1159276,14.1904478 10.8847401,14.5871642 10.8847401,14.9126866 Z",
    id: "XMLID_1483_",
    fill: "url(#linearGradient-128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00594737,15.9904478 C9.00594737,16.3159701 9.23713487,16.4471642 9.52285197,16.2832836 C9.80811842,16.119403 10.0397566,15.7231343 10.0397566,15.3976119 C10.0397566,15.0720896 9.80856908,14.9408955 9.52285197,15.1047761 C9.23713487,15.268209 9.00594737,15.6649254 9.00594737,15.9904478 Z",
    id: "XMLID_1482_",
    fill: "url(#linearGradient-129)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1472_",
    transform: "translate(0.000000, 7.611940)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1480_",
    fill: "url(#linearGradient-130)",
    points: "0.325375 22.47 28.7398059 6.17014925 28.7398059 0.164776119 0.325375 16.4641791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1479_",
    fill: "url(#linearGradient-131)",
    points: "1.30735855 20.6435821 3.46240461 19.4073134 3.46240461 15.6864179 1.30735855 16.9226866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1478_",
    fill: "url(#linearGradient-132)",
    points: "4.37318421 18.8847761 6.52868092 17.6485075 6.52868092 13.9276119 4.37318421 15.1638806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1477_",
    fill: "url(#linearGradient-133)",
    points: "19.5094309 7.34641791 28.0070362 2.47208955 28.0070362 1.60656716 19.5094309 6.48089552"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1476_",
    fill: "url(#linearGradient-134)",
    points: "21.6018355 9.00179104 28.0070362 5.32791045 28.0070362 4.46238806 21.6018355 8.13626866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8275263,13.758806 C12.8275263,14.0843284 13.0587138,14.2155224 13.3444309,14.0516418 C13.6296974,13.8877612 13.8613355,13.4914925 13.8613355,13.1659701 C13.8613355,12.8404478 13.630148,12.7092537 13.3444309,12.8731343 C13.0591645,13.0370149 12.8275263,13.4332836 12.8275263,13.758806 Z",
    id: "XMLID_1475_",
    fill: "url(#linearGradient-135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8847401,14.8737313 C10.8847401,15.1992537 11.1159276,15.3304478 11.4016447,15.1665672 C11.6869112,15.0026866 11.9185493,14.6064179 11.9185493,14.2808955 C11.9185493,13.9553731 11.6873618,13.8241791 11.4016447,13.9880597 C11.1159276,14.1514925 10.8847401,14.548209 10.8847401,14.8737313 Z",
    id: "XMLID_1474_",
    fill: "url(#linearGradient-136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00594737,15.9510448 C9.00594737,16.2765672 9.23713487,16.4077612 9.52285197,16.2438806 C9.80811842,16.08 10.0397566,15.6837313 10.0397566,15.358209 C10.0397566,15.0326866 9.80856908,14.9014925 9.52285197,15.0653731 C9.23713487,15.2292537 9.00594737,15.6259701 9.00594737,15.9510448 Z",
    id: "XMLID_1473_",
    fill: "url(#linearGradient-137)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1465_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1469_",
    transform: "translate(0.000000, 25.522388)",
    fill: "url(#linearGradient-138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.597125,25.828209 L48.6868257,56.9762687 L48.6868257,56.9762687 C47.3961414,57.7334328 45.7945033,57.738806 44.4993125,56.9897015 L2.05094408,32.4416418 C0.851292763,31.7480597 0.113565789,30.4728358 0.113565789,29.0937313 L0.113565789,0.170149254 L46.597125,25.828209 Z",
    id: "XMLID_1470_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1467_",
    transform: "translate(46.417763, 26.865672)",
    fill: "url(#linearGradient-139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7192237,0.21358209 L43.7192237,29.0973134 C43.7192237,30.4674627 42.9905099,31.7355224 41.803477,32.4326866 L2.20236513,55.6728358 C1.30825987,56.1976119 0.179361842,55.5573134 0.179361842,54.5256716 L0.179361842,23.1967164 L43.7192237,0.21358209 Z",
    id: "XMLID_1468_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.4902928,28.3361194 L49.1126974,52.0871642 C47.2893355,53.16 45.0234276,53.1644776 43.1955592,52.0997015 L0.997305921,27.5180597 C-0.198289474,26.821791 -0.175756579,25.0970149 1.03741447,24.4316418 L43.7309408,1.00925373 C45.5885526,-0.00985074627 47.8562632,0.0546268657 49.6521349,1.17716418 L89.5209375,26.0995522 C90.3560066,26.621194 90.3393322,27.8364179 89.4902928,28.3361194 Z",
    id: "XMLID_1466_",
    fill: "url(#linearGradient-140)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.473684, 52.388060)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34837829,24.7097015 L2.71025658,24.5019403 C3.99282895,23.7662687 5.03294737,21.7920896 5.03294737,20.0928358 L5.03294737,2.36731343 C5.03294737,0.668059701 3.99327961,-0.113283582 2.71025658,0.622835821 L2.34837829,0.830597015 C1.06580592,1.56626866 0.0256875,3.54044776 0.0256875,5.23970149 L0.0256875,22.9652239 C0.0256875,24.6644776 1.06580592,25.4458209 2.34837829,24.7097015 Z",
    fill: "url(#linearGradient-141)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.351974, 4.477612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0779638158,2.89029851 C0.0779638158,3.73791045 0.680493421,4.07910448 1.42362829,3.65283582 C2.16676316,3.22656716 2.76929276,2.19402985 2.76929276,1.34641791 C2.76929276,0.49880597 2.16676316,0.15761194 1.42362829,0.583880597 C0.680493421,1.01014925 0.0779638158,2.04313433 0.0779638158,2.89029851 Z",
    fill: "url(#linearGradient-142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0779638158,9.05283582 C0.0779638158,9.90044776 0.680493421,10.2416418 1.42362829,9.81537313 C2.16676316,9.38910448 2.76929276,8.35656716 2.76929276,7.50895522 C2.76929276,6.66134328 2.16676316,6.32014925 1.42362829,6.74641791 C0.680493421,7.17268657 0.0779638158,8.20522388 0.0779638158,9.05283582 Z",
    fill: "url(#linearGradient-143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0779638158,15.0308955 C0.0779638158,15.8785075 0.680493421,16.2197015 1.42362829,15.7934328 C2.16676316,15.3671642 2.76929276,14.3346269 2.76929276,13.4870149 C2.76929276,12.639403 2.16676316,12.298209 1.42362829,12.7244776 C0.680493421,13.151194 0.0779638158,14.1837313 0.0779638158,15.0308955 Z",
    fill: "url(#linearGradient-144)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1446_",
    transform: "translate(58.585526, 38.059701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1456_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1464_",
    fill: "url(#linearGradient-145)",
    points: "0.112213816 22.7426866 28.5266447 6.44283582 28.5266447 0.437462687 0.112213816 16.7373134"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1463_",
    fill: "url(#linearGradient-146)",
    points: "1.09419737 20.9162687 3.24924342 19.68 3.24924342 15.9591045 1.09419737 17.1953731"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1462_",
    fill: "url(#linearGradient-147)",
    points: "4.16002303 19.1574627 6.31551974 17.921194 6.31551974 14.2002985 4.16002303 15.4365672"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1461_",
    fill: "url(#linearGradient-148)",
    points: "14.9834737 10.0934328 27.7934243 2.74477612 27.7934243 1.87925373 14.9834737 9.22791045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1460_",
    fill: "url(#linearGradient-149)",
    points: "17.5508717 11.4761194 27.7934243 5.60059701 27.7934243 4.73507463 17.5508717 10.610597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6143651,14.0314925 C12.6143651,14.3570149 12.8455526,14.488209 13.1312697,14.3243284 C13.4165362,14.1604478 13.6481743,13.7641791 13.6481743,13.4386567 C13.6481743,13.1131343 13.4165362,12.9819403 13.1312697,13.1458209 C12.8455526,13.3097015 12.6143651,13.7064179 12.6143651,14.0314925 Z",
    id: "XMLID_1459_",
    fill: "url(#linearGradient-150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6711283,15.1464179 C10.6711283,15.4719403 10.9023158,15.6031343 11.1880329,15.4392537 C11.4732993,15.2753731 11.7049375,14.8791045 11.7049375,14.5535821 C11.7049375,14.2280597 11.47375,14.0968657 11.1880329,14.2607463 C10.9027664,14.4241791 10.6711283,14.8208955 10.6711283,15.1464179 Z",
    id: "XMLID_1458_",
    fill: "url(#linearGradient-151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79233553,16.2241791 C8.79233553,16.5497015 9.02352303,16.6808955 9.30924013,16.5170149 C9.59450658,16.3531343 9.82614474,15.9568657 9.82614474,15.6313433 C9.82614474,15.3058209 9.59495724,15.1746269 9.30924013,15.3385075 C9.02397368,15.5019403 8.79233553,15.8986567 8.79233553,16.2241791 Z",
    id: "XMLID_1457_",
    fill: "url(#linearGradient-152)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1447_",
    transform: "translate(0.000000, 7.611940)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1455_",
    fill: "url(#linearGradient-153)",
    points: "0.112213816 22.7037313 28.5266447 6.4038806 28.5266447 0.398507463 0.112213816 16.6979104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1454_",
    fill: "url(#linearGradient-154)",
    points: "1.09419737 20.8773134 3.24924342 19.6410448 3.24924342 15.9201493 1.09419737 17.1564179"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1453_",
    fill: "url(#linearGradient-155)",
    points: "4.16002303 19.1185075 6.31551974 17.8822388 6.31551974 14.1613433 4.16002303 15.3976119"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1452_",
    fill: "url(#linearGradient-156)",
    points: "19.2962697 7.58014925 27.7934243 2.7058209 27.7934243 1.84029851 19.2962697 6.71462687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1451_",
    fill: "url(#linearGradient-157)",
    points: "21.3886743 9.23552239 27.7934243 5.56164179 27.7934243 4.6961194 21.3886743 8.37044776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6143651,13.9925373 C12.6143651,14.3180597 12.8455526,14.4492537 13.1312697,14.2853731 C13.4165362,14.1214925 13.6481743,13.7252239 13.6481743,13.3997015 C13.6481743,13.0741791 13.4165362,12.9429851 13.1312697,13.1068657 C12.8455526,13.2707463 12.6143651,13.6674627 12.6143651,13.9925373 Z",
    id: "XMLID_1450_",
    fill: "url(#linearGradient-158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6711283,15.1074627 C10.6711283,15.4329851 10.9023158,15.5641791 11.1880329,15.4002985 C11.4732993,15.2364179 11.7049375,14.8401493 11.7049375,14.5146269 C11.7049375,14.1891045 11.47375,14.0579104 11.1880329,14.221791 C10.9027664,14.3852239 10.6711283,14.7819403 10.6711283,15.1074627 Z",
    id: "XMLID_1449_",
    fill: "url(#linearGradient-159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79233553,16.1847761 C8.79233553,16.5102985 9.02352303,16.6414925 9.30924013,16.4776119 C9.59450658,16.3137313 9.82614474,15.9174627 9.82614474,15.5919403 C9.82614474,15.2664179 9.59495724,15.1352239 9.30924013,15.2991045 C9.02397368,15.4629851 8.79233553,15.8597015 8.79233553,16.1847761 Z",
    id: "XMLID_1448_",
    fill: "url(#linearGradient-160)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.661184, 47.910448)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3445691,29.1116418 L0.0211809211,13.3262687 L0.0211809211,5.52044776 C0.0211809211,1.08358209 2.73639474,-0.955970149 6.08523355,0.965373134 L21.2800658,9.6819403 C24.6293553,11.6032836 27.3441184,16.7574627 27.3441184,21.1943284 L27.3441184,29.1116418 L27.3445691,29.1116418 Z",
    fill: "url(#linearGradient-161)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.759868, 7.164179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67960197,3.50059701 C2.42273684,3.92686567 3.02526645,3.58567164 3.02526645,2.7380597 C3.02526645,1.89044776 2.42273684,0.857910448 1.67960197,0.431641791 C0.936467105,0.00537313433 0.333937247,0.346567164 0.333937247,1.1941791 C0.333486842,2.04179104 0.936016447,3.07432836 1.67960197,3.50059701 Z",
    fill: "url(#linearGradient-162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08434211,6.60134328 C7.82747697,7.02761194 8.43000658,6.68641791 8.43000658,5.83880597 C8.43000658,4.99119403 7.82747697,3.95865672 7.08434211,3.53238806 C6.34120724,3.1061194 5.73867763,3.44731343 5.73867763,4.29492537 C5.73867763,5.14253731 6.34120724,6.17507463 7.08434211,6.60134328 Z",
    fill: "url(#linearGradient-163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3281974,9.60940299 C13.0713322,10.0356716 13.6738618,9.69447761 13.6738618,8.84686567 C13.6738618,7.99925373 13.0713322,6.96671642 12.3281974,6.54044776 C11.5850625,6.1141791 10.9825329,6.45537313 10.9825329,7.30298507 C10.9825329,8.15014925 11.5850625,9.18313433 12.3281974,9.60940299 Z",
    fill: "url(#linearGradient-164)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_4",
    transform: "translate(557.000000, 185.000000)",
    fillRule: "nonzero",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4776053,6.21982759 L4.50813158,12.3020345 C4.04286842,12.5615862 3.53868421,12.6844138 3.04121053,12.6844138 C1.97871053,12.6844138 0.947526316,12.1218276 0.395026316,11.1253103 C-0.4165,9.66258621 0.108710526,7.81703448 1.56936842,7.00341379 L13.2846053,0.517758621 C13.2846053,0.517758621 14.8418947,-0.247896552 16.1777368,2.05803448 C17.4276842,4.21648276 17.0187895,5.447 15.4776053,6.21982759 Z",
    id: "Shape",
    fill: "url(#linearGradient-165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9364737,4.24696552 C16.9364737,5.57744828 15.9987895,6.11313793 14.8414474,5.44386207 C13.6845526,4.77458621 12.7464211,3.15362069 12.7468683,1.82313793 C12.7468683,0.492655172 13.6845526,-0.0430344828 14.8414474,0.626241379 C15.9983421,1.29596552 16.9364737,2.91693103 16.9364737,4.24696552 Z",
    id: "Shape",
    fill: "url(#linearGradient-166)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "server_1",
    transform: "translate(481.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-167)",
    fillRule: "nonzero",
    points: "43.827443 177.616131 77.1947919 177.616131 133.867799 151.217742 65.9752148 117.231879"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1408_",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1412_",
    transform: "translate(41.369128, 25.171717)",
    fill: "url(#linearGradient-168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45831544,26.1255455 L0.373221477,151.870409 L0.373221477,151.870409 C1.6610604,152.630505 3.25916779,152.635899 4.55150336,151.883894 L46.9062953,127.240783 C48.103302,126.544515 48.8394027,125.264354 48.8394027,123.879909 L48.8394027,0.368136364 L2.45831544,26.1255455 Z",
    id: "XMLID_1413_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1410_",
    transform: "translate(0.000000, 26.520202)",
    fill: "url(#linearGradient-169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.383563758,0.411737374 L0.383563758,123.883505 C0.383563758,125.25896 1.11067114,126.531929 2.29508725,127.231793 L41.8088993,150.561929 C42.7010336,151.088737 43.827443,150.44596 43.827443,149.410323 L43.827443,23.4838636 L0.383563758,0.411737374 Z",
    id: "XMLID_1411_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.02883221,28.1936717 L41.3174161,52.0366818 C43.1367584,53.1136717 45.3976711,53.1181667 47.2215101,52.0492677 L89.3267383,27.3724444 C90.519698,26.6734798 90.4972148,24.9420253 89.2867181,24.2740758 L46.6873087,0.760545455 C44.8337919,-0.262505051 42.5710805,-0.197777778 40.7791678,0.929106061 L0.998255034,25.9479949 C0.16547651,26.4721061 0.18166443,27.6920354 1.02883221,28.1936717 Z",
    id: "XMLID_1409_",
    fill: "url(#linearGradient-170)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.261745, 67.424242)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1407_",
    fill: "url(#linearGradient-171)",
    points: "0.0962281879 21.7011667 33.5746443 2.37962626 33.5746443 0.344313131 0.0962281879 19.665404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1406_",
    fill: "url(#linearGradient-171)",
    points: "0.0962281879 33.0787828 33.5746443 13.7576919 33.5746443 11.7219293 0.0962281879 31.0430202"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1405_",
    fill: "url(#linearGradient-171)",
    points: "0.0962281879 44.456399 33.5746443 25.1353081 33.5746443 23.0995455 0.0962281879 42.4210859"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1404_",
    fill: "url(#linearGradient-171)",
    points: "0.0962281879 55.8340152 33.5746443 36.5129242 33.5746443 34.4771616 0.0962281879 53.798702"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1403_",
    fill: "url(#linearGradient-172)",
    points: "0.0962281879 67.2116313 33.5746443 47.8905404 33.5746443 45.8547778 0.0962281879 65.1763182"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7865839,47.7300707 L19.7865839,40.4190354 C19.7865839,39.6953485 20.1652013,39.0242525 20.7848389,38.6493737 L65.5480336,11.170399",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.426906,156.384687 L20.2933557,164.378505",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5334765,156.847217 L20.0532349,156.569879 C18.351255,155.587732 16.9712349,152.952343 16.9712349,150.683742 L16.9712349,49.6831263 C16.9712349,47.4145253 18.3508054,46.371697 20.0532349,47.3542929 L20.5334765,47.6316313 C22.2354564,48.6137778 23.6154765,51.2491667 23.6154765,53.5177677 L23.6154765,154.518384 C23.6154765,156.786985 22.235906,157.829813 20.5334765,156.847217 Z",
    id: "Shape",
    fill: "url(#linearGradient-173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6194564,161.521515 L72.6194564,140.705854 C72.6194564,138.437253 71.2394362,137.394424 69.5374564,138.37702 L69.0572148,138.654359 C67.3552349,139.636505 65.9752148,142.271894 65.9752148,144.540495 L65.9752148,165.387172",
    id: "Shape",
    fill: "url(#linearGradient-174)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1497383,146.499394 C67.1497383,147.860015 68.1111208,148.407949 69.2973356,147.723369 C70.4835503,147.038788 71.4449329,145.381051 71.4449329,144.020429 C71.4449329,142.659808 70.4835503,142.111874 69.2973356,142.796455 C68.1111208,143.481035 67.1497383,145.138773 67.1497383,146.499394 Z",
    id: "Shape",
    fill: "url(#linearGradient-175)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6538792,121.894939 L51.4928725,141.610237 C50.3282416,142.282232 48.8726779,141.442126 48.8726779,140.098136 L48.8726779,83.395697 C48.8726779,82.2049848 49.5080537,81.1046212 50.5395839,80.5094899 L84.7005906,60.7941919 C85.8647718,60.122197 87.3203365,60.962303 87.3203365,62.3062929 L87.3203365,119.008732 C87.3212349,120.199444 86.6854094,121.299359 85.6538792,121.894939 Z",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0087
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1395_",
    transform: "translate(12.140940, 5.393939)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2280067,39.5016162 L62.2061275,23.3544091 C63.3437785,22.697697 62.8657852,18.7479848 62.7128993,18.5286313 L31.6631208,1.85371717 L0.438758581,19.0082424 C0.438758581,19.0082424 0.404248322,22.8163636 1.54234899,23.4730758 L29.3145235,39.5011667 C30.8348389,40.3790303 32.7076913,40.3790303 34.2280067,39.5016162 Z",
    id: "XMLID_1402_",
    fill: "url(#linearGradient-176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9681007,36.6931717 L61.9462215,20.5459646 C63.0838725,19.8892525 63.0838725,18.247697 61.9462215,17.5909848 L31.7170805,0.144737374 L1.28199329,17.7096515 C0.144342282,18.3663636 0.144342282,20.0079192 1.28199329,20.6646313 L29.0541678,36.6927222 C30.5749329,37.5705859 32.4477852,37.5705859 33.9681007,36.6931717 Z",
    id: "XMLID_1401_",
    fill: "url(#linearGradient-177)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1396_",
    transform: "translate(18.436242, 9.888889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1399_",
    transform: "translate(0.000000, 1.348485)",
    fill: "url(#linearGradient-178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9598121,12.678904 C17.0463289,15.5075758 9.05534228,15.4927424 4.11083221,12.6465404 C-0.833677852,9.80033838 -0.858409396,5.19975758 4.05462416,2.37153535 C8.96810738,-0.457136364 16.959094,-0.44230303 21.903604,2.40389899 C26.8481141,5.25010101 26.8732953,9.85023232 21.9598121,12.678904 Z",
    id: "XMLID_1400_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1397_",
    fill: "url(#linearGradient-179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9598121,12.5813636 C17.0463289,15.4100354 9.05534228,15.395202 4.11083221,12.549 C-0.833677852,9.70279798 -0.858409396,5.10221717 4.05462416,2.27399495 C8.96810738,-0.554676768 16.959094,-0.539843434 21.903604,2.30635859 C26.8481141,5.15256061 26.8732953,9.75269192 21.9598121,12.5813636 Z",
    id: "XMLID_1398_"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.691275, 61.580808)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.323263758,
    y: 0.323141919,
    width: 16.1879195,
    height: 49.8939394,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4496443,42.673702 L8.30260403,42.5887475 C7.78099329,42.2875859 7.35785906,41.4798434 7.35785906,40.7844747 L7.35785906,8.2590202 C7.35785906,7.56365152 7.78099329,7.24406061 8.30260403,7.54522222 L8.45009396,7.63017677 C8.9717047,7.93133838 9.39483893,8.73908081 9.39483893,9.43444949 L9.39483893,41.959904 C9.39438926,42.6552727 8.9717047,42.9748636 8.4496443,42.673702 Z",
    id: "Shape",
    fill: "url(#linearGradient-180)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.6725705,160.892672 L73.6725705,139.97003 C73.6725705,136.912116 71.8127584,135.506995 69.5185705,136.830758 L68.8710537,137.204288 C66.5768658,138.5285 64.7170537,142.080409 64.7170537,145.138323 L64.7170537,166.103217",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 0.5391
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.383563758,126.736 L9.87957718,132.216242 C11.0442081,132.888237 12.4997718,132.048131 12.4997718,130.704141 L12.4997718,74.001702 C12.4997718,72.8109899 11.864396,71.7110758 10.8328658,71.1154949 L0.384013423,65.0850707",
    id: "Shape",
    stroke: "#00C6FB",
    strokeWidth: 1.0087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2714698,115.354338 L5.95490604,115.171843 C4.83344295,114.524571 3.92422148,112.788172 3.92422148,111.293601 L3.92422148,88.1801212 C3.92422148,86.6855505 4.83344295,85.9982727 5.95490604,86.6455455 L6.2714698,86.8280404 C7.39293289,87.4753131 8.30215436,89.2117121 8.30215436,90.7062828 L8.30215436,113.819763 C8.3017047,115.314783 7.39293289,116.001611 6.2714698,115.354338 Z",
    id: "Shape",
    fill: "url(#linearGradient-181)",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_3",
    transform: "translate(548.000000, 223.000000)",
    fillRule: "nonzero",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11278261,7.25602941 L15.4313478,14.3779412 C15.9960652,14.6814706 16.6087174,14.8257353 17.2122391,14.8257353 C18.501913,14.8257353 19.7541522,14.1670588 20.4252391,13.0001471 C21.410413,11.2870588 20.7726522,9.12617647 18.9995217,8.17367647 L4.77567391,0.579264706 C4.77567391,0.579264706 2.88476087,-0.317205882 1.26273913,2.38323529 C-0.25473913,4.91073529 0.241956522,6.35117647 2.11278261,7.25602941 Z",
    id: "Shape",
    fill: "url(#linearGradient-182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.341934783,4.94602941 C0.341934783,6.50382353 1.4805,7.13117647 2.88521739,6.34720588 C4.28993478,5.56367647 5.4285,3.66529412 5.4285,2.1075 C5.4285,0.549705882 4.28993478,-0.0776470588 2.88521739,0.706323529 C1.4805,1.49029412 0.341934783,3.38867647 0.341934783,4.94602941 Z",
    id: "Shape",
    fill: "url(#linearGradient-183)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "control_1",
    transform: "translate(549.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 16.225352)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-184)",
    fillRule: "nonzero",
    points: "36.22005 79.1900845 69.7419 79.6795493 125.66475 47.0742535 61.7679 9.92721127 36.4707 25.1907606"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 20.732394)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-185)",
    points: "36.22005 58.5469296 0.3006 37.7762254 0.31185 21.1118873 36.2313 41.8825915"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-186)",
    points: "36.22005 58.5469296 72.1395 37.7762254 72.15075 21.1118873 36.2313 41.8825915"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-187)",
    points: "36.23175 41.8816901 0.31185 21.1118873 36.2313 0.342084507 72.15075 21.1118873"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-188)",
    points: "36.2259 58.4374085 0.306 37.6667042 0.31725 21.0023662 36.23715 41.7730704"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-189)",
    points: "36.2259 58.4374085 72.14535 37.6667042 72.1566 21.0023662 36.23715 41.7730704"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-190)",
    points: "36.23715 41.772169 0.31725 21.0023662 36.2367 0.23256338 72.1566 21.0023662"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.06725,54.4815775 L43.06725,50.2345915 C43.06725,49.0672676 43.68645,47.9882817 44.69355,47.4001127 L55.2411,41.243493 C56.5299,40.4912676 57.3228,39.1094085 57.3228,37.6153239 L57.3228,29.580169",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4192,53.3205634 L65.3715,49.8798873 C65.3715,49.5193239 64.98225,49.2939718 64.6704,49.4742535 L52.8273,56.3096338 C52.4835,56.5083944 52.05375,56.2596056 52.05375,55.8616338 L52.05375,54.5577465 C52.05375,53.8916056 51.6681,53.2863099 51.0651,53.0059718 L48.0474,51.6020282",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-191)",
    fillRule: "nonzero",
    points: "62.8749 56.755831 67.96305 53.8131831 67.96305 51.0638873 62.8749 54.0060845"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.150000, 42.816901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9106,10.4018028 L2.9106,3.33611268 C2.9106,2.59876056 3.3138,1.92090141 3.9609,1.56980282 L6.63435,0.118985915",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-192)",
    fillRule: "nonzero",
    points: "5.45445 14.2260282 0.3663 11.2833803 0.3663 8.53408451 5.45445 11.4767324"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1179,67.3257465 L27.1179,74.1521127",
    stroke: "#FBF8FF",
    strokeWidth: 0.5604,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-193)",
    fillRule: "nonzero",
    points: "29.6622 69.1637183 24.5736 66.2215211 24.5736 63.4722254 29.6622 66.4144225"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.300000, 0.000000)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-194)",
    points: "21.72375 45.3534648 0.30015 32.9649577 0.30015 1.8131831 5.5071 0.24743662 21.72375 9.62433803"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-195)",
    points: "5.5071 0.24743662 5.5071 4.82433803 0.30015 1.8131831"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-196)",
    points: "18.02925 16.9789296 4.1436 8.9496338 4.1436 7.72191549 18.02925 15.751662"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-197)",
    points: "19.7649 21.4025915 2.259 11.2797746 2.259 10.0520563 19.7649 20.1748732"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-198)",
    points: "19.7649 24.8220845 2.259 14.6992676 2.259 13.472 19.7649 23.5948169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-199)",
    points: "19.7649 28.2420282 2.259 18.1192113 2.259 16.891493 19.7649 27.0143099"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-200)",
    points: "19.7649 31.6615211 2.259 21.5387042 2.259 20.3114366 19.7649 30.4342535"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-201)",
    points: "19.7649 35.0814648 2.259 24.9586479 2.259 23.7309296 19.7649 33.8537465"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-202)",
    points: "19.7649 38.5009577 2.259 28.3781408 2.259 27.1508732 19.7649 37.2736901"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 4.507042)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2465,42.3211268 L4.8564,28.7918873 C4.38795,28.5210141 4.4469,28.0477746 4.9878,27.7354366 L4.9878,27.7354366 C5.5287,27.4226479 6.3468,27.3888451 6.81525,27.6597183 L30.20535,41.1889577 C30.6738,41.459831 30.61485,41.9330704 30.07395,42.2454085 L30.07395,42.2454085 C29.53305,42.5581972 28.71495,42.592 28.2465,42.3211268 Z",
    fill: "url(#linearGradient-203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8564,28.7918873 C4.8564,28.7918873 4.50765,28.6134085 4.54005,28.300169 C3.3561,21.3949296 0.03465,0.317295775 0.03465,0.317295775 L38.7855,16.8955493 L30.3678,42.0110423 C30.3678,42.0110423 29.6397,42.8425915 28.2465,42.3211268 L4.8564,28.7918873 Z",
    fill: "url(#linearGradient-204)",
    opacity: 0.7
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_2",
    transform: "translate(601.000000, 263.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient-205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118,68.5523837 C104.660145,60.5255814 4.6438855,0.374255814 4.6438855,0.374255814 C4.3979771,0.232790698 3.12609924,-0.436930233 1.24980916,2.07362791 C-0.113045802,3.89700581 0.108091603,6.01719186 0.899412214,6.5293314 L118,76.9865698 L118,68.5523837 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.19321374,4.92665698 C0.19321374,6.54589535 1.34393893,7.1977093 2.76354198,6.38338953 C4.18314504,5.56906977 5.33387023,3.59572093 5.33387023,1.97693023 C5.33387023,0.358139535 4.18314504,-0.294122093 2.76354198,0.520197674 C1.34393893,1.33451744 0.19321374,3.30786628 0.19321374,4.92665698 Z",
    fill: "url(#linearGradient-206)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(8.557252, 4.476744)",
    fill: "#E2FEFF",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5356031,50.0083663 L0.582343511,2.53831395 C0.0360305344,2.22001744 -0.147725191,1.52119767 0.172946565,0.97772093 C0.493167939,0.434244186 1.19666412,0.253383721 1.7429771,0.570784884 L79.5356031,47.3433605 L79.5356031,50.0083663 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_1",
    transform: "translate(526.000000, 263.000000)",
    fillRule: "nonzero",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient-207)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.908875,6.69454545 C41.908875,6.69454545 7.8045,27.6954545 5.71855208,29.0127273 C5.627625,29.0777273 5.53266667,29.1386364 5.434125,29.1959091 C3.7221875,30.1895455 1.50276042,29.6240909 0.501666667,27.9004545 C0.32384375,27.5945455 -1.09426042,24.9395455 1.85661458,22.8504545 L1.85571875,22.8481818 C1.86378125,22.8436364 1.87139583,22.8390909 1.87945833,22.8345455 C1.978,22.7654545 2.08102083,22.6972727 2.18941667,22.6290909 C2.50385417,22.4322727 2.96834375,22.1436364 3.56586458,21.7722727 C4.75329167,21.0354545 38.1848958,0.444545455 38.1848958,0.444545455 C38.4294583,0.300909091 39.694375,-0.379090909 41.5603958,2.17 C42.9153437,4.02181818 42.6954167,6.17454545 41.908875,6.69454545 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.6103125,5.06727273 C42.6103125,6.71136364 41.4658854,7.37318182 40.0540521,6.54636364 C38.6422187,5.71954545 37.4977917,3.71590909 37.4977917,2.07227273 C37.4977917,0.428181818 38.6422187,-0.233636364 40.0540521,0.593181818 C41.4658854,1.42045455 42.6103125,3.42363636 42.6103125,5.06727273 Z",
    id: "Shape",
    fill: "url(#linearGradient-208)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pipe_9",
    transform: "translate(83.000000, 253.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.506201,74.9254491 L133.104617,74.9254491 C134.317045,74.9254491 135.510633,74.6267964 136.580422,74.055988 L169.868575,54.9884731 L157.767625,46.2714072 L120.742164,71.1943114 C120.742164,71.1943114 115.277942,74.9254491 108.506201,74.9254491 Z",
    id: "Shape",
    fill: "url(#linearGradient-209)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "url(#linearGradient-210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.099631,74.5607784 C105.423325,74.5607784 101.73715,73.6333832 98.3802111,71.7651198 L3.58614776,19.1137725 C1.5492876,17.9797904 0.275408971,15.8263473 0.260932901,13.4928144 C0.246701847,11.1597305 1.49456464,8.99101796 3.51707124,7.83233533 L16.4159894,0.329191617 C16.4446966,0.312125749 17.9083113,-0.664670659 20.0070712,2.47275449 C20.9750396,3.91976048 21.0077836,6.06781437 20.018285,6.64535928 L10.3457784,12.2110778 C9.41773087,12.7522455 9.43118734,14.0995509 10.37,14.6218563 L101.886966,65.4494012 C106.767625,68.1655689 112.684433,67.9244012 117.32781,64.8202096 L157.278259,38.1224551 C158.51715,37.5260479 160.014855,38.2607784 161.068945,40.0863772 C162.030633,41.7525449 162.112269,43.6513473 161.182876,44.2010479 L121.335594,70.8296407 C117.625646,73.3095808 113.369367,74.5607784 109.099631,74.5607784 Z M7.13147757,14.0856287 L7.12564644,14.0892216 C7.12744063,14.0883234 7.12923483,14.086976 7.13147757,14.0856287 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7507652,4.98188623 C20.7507652,6.61437126 19.5988918,7.27230539 18.1774406,6.4508982 C16.756438,5.62949102 15.6041161,3.63997006 15.6041161,2.00703593 C15.6041161,0.374101796 16.7559894,-0.283383234 18.1774406,0.538023952 C19.5988918,1.35988024 20.7507652,3.3494012 20.7507652,4.98188623 Z",
    fill: "url(#linearGradient-211)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.823852,42.6143713 C161.823852,44.2473054 160.671979,44.9047904 159.250528,44.0833832 C157.829525,43.261976 156.677203,41.2724551 156.677203,39.639521 C156.677203,38.0065868 157.829077,37.3491018 159.250528,38.170509 C160.671979,38.9923653 161.823852,40.9818862 161.823852,42.6143713 Z",
    fill: "url(#linearGradient-212)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(15.250660, 18.862275)",
    fill: "#E2FEFF",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8903694,50.0982036 C86.2819525,50.0982036 86.6641161,49.8961078 86.8771768,49.5327844 C87.196095,48.9875749 87.0130871,48.2865269 86.4694459,47.9672156 L2.01443272,0.574850299 C1.47034301,0.256886228 0.769709763,0.438323353 0.450791557,0.983083832 C0.131873351,1.52829341 0.314881266,2.22934132 0.858522427,2.54865269 L85.3135356,49.9405689 C85.4951979,50.0479042 85.6943536,50.0982036 85.8903694,50.0982036 Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-213)",
    opacity: 0.8,
    cx: 74.7672559,
    cy: 54.4437126,
    rx: 1.59593668,
    ry: 1.59790419
  }))), /*#__PURE__*/React.createElement("g", {
    id: "main_server",
    transform: "translate(226.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 53.036559)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-214)",
    cx: 157.472467,
    cy: 101.783899,
    rx: 145.356956,
    ry: 54.0838065
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.743102,82.7684946 C236.753427,82.2480172 236.750678,81.7275398 236.743102,81.2070624 L236.743102,68.7816753 L234.53816,68.7816753 C230.1992,55.9953699 219.48916,43.8077484 202.38784,33.9218237 C156.35608,7.3114043 81.4899422,7.44714194 35.1690978,34.2243118 C18.1485778,44.0634925 7.35908444,56.1320065 2.79253778,68.7816753 L0.275617778,68.7816753 L0.275617778,82.608486 C0.275617778,82.6197226 0.275617778,82.6305097 0.275617778,82.6417462 L0.275617778,83.6701161 L0.291328889,83.6701161 C0.650888889,100.811262 12.0899244,117.852628 34.6456933,130.891531 C80.6774533,157.501951 155.543591,157.366213 201.864436,130.589043 C224.373071,117.577108 235.996151,100.668783 236.71976,83.6701161 L236.743102,83.6701161 L236.743102,82.7684946 Z",
    fill: "url(#linearGradient-215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.387391,20.1040022 C248.419151,46.7144215 248.184382,89.9936022 201.863987,116.771222 C155.543142,143.548841 80.6770044,143.684129 34.6452444,117.07371 C-11.3865156,90.4632903 -11.1517467,47.1841097 35.1686489,20.4064903 C81.4894933,-6.37112903 156.35608,-6.5064172 202.387391,20.1040022 Z",
    fill: "url(#linearGradient-216)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.751111, 45.845161)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.962213,85.0369312 C222.962213,109.735787 195.892418,128.788497 129.511627,128.788497 C63.1308356,128.788497 9.31848444,108.766297 9.31848444,84.0674409 C9.31848444,59.3685849 63.1308356,39.3463849 129.511627,39.3463849 C195.892418,39.3463849 222.962213,60.3385247 222.962213,85.0369312 Z",
    fill: "url(#linearGradient-217)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.553956,68.4495226 C195.562484,68.0189376 195.562484,67.5888022 195.553956,67.1586667 L195.553956,56.8844065 L193.730569,56.8844065 C190.1426,46.3112538 181.28692,36.2338581 167.146022,28.0590366 C129.083387,6.05515699 67.17712,6.16752258 28.8752267,28.3093871 C14.8012133,36.4455548 5.87954667,46.4245183 2.10349333,56.8844065 L0.0224444444,56.8844065 L0.0224444444,68.3173806 C0.0224444444,68.3263699 0.0224444444,68.3358086 0.0224444444,68.3447978 L0.0224444444,69.1951806 L0.0354622222,69.1951806 C0.332626667,83.3689763 9.79161333,97.460071 28.4424978,108.242224 C66.5051333,130.246103 128.4114,130.133738 166.713293,107.991873 C185.325124,97.232643 194.936284,83.2512172 195.534653,69.1951806 L195.553956,69.1951806 L195.553956,68.4495226 L195.553956,68.4495226 Z",
    fill: "url(#linearGradient-218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.146022,16.6328043 C205.208658,38.6366839 205.015187,74.4233269 166.713293,96.5651914 C128.4114,118.707056 66.5055822,118.818972 28.4424978,96.8155419 C-9.62058667,74.8121118 -9.42666667,39.0250194 28.8752267,16.8831548 C67.17712,-5.25870968 129.082938,-5.37062581 167.146022,16.6328043 Z",
    fill: "url(#linearGradient-219)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.529053,130.529265 L180.612689,144.292252 C181.366822,144.637439 181.850276,145.391187 181.850276,146.220895 L181.850276,150.583826 C181.850276,151.307011 181.438644,151.965024 180.787307,152.278748 C176.759427,154.217729 161.793471,160.96371 144.685418,162.967862",
    id: "Shape",
    stroke: "#FBF8FF",
    strokeWidth: 0.8268,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.953529,144.095387 L188.483058,142.51328 C188.483058,142.51328 199.434151,140.946903 199.238436,129.590338 C199.238436,129.590338 207.060773,116.417495 203.931569,105.773327 C203.931569,105.773327 204.127284,82.2057677 189.656004,74.1779204 C175.185173,66.1500731 141.57372,61.9790624 129.207729,64.8120237 C116.841738,67.6449849 113.56036,67.1227097 113.56036,67.1227097 L145.953529,144.095387 Z",
    id: "Shape",
    fill: "url(#linearGradient-220)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.622222, 62.924731)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.093987,23.6866667 L124.047302,40.2426129 C124.028898,46.8034151 118.435293,50.8701505 117.989996,51.1937634 L118.03668,34.6378172 C118.481978,34.3137548 124.075582,30.2470194 124.093987,23.6866667 Z",
    id: "Shape",
    fill: "url(#linearGradient-221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.03668,34.6378172 C130.254538,46.0860731 120.211547,59.5164581 100.995511,63.8398366 C100.535849,63.9432129 100.079778,64.0362516 99.6259511,64.1238968 C98.9615956,64.2501957 98.5302133,64.324357 98.1015244,64.3922258 C97.4183156,64.4965011 96.9855867,64.5580774 96.5564489,64.6106645 C96.0379822,64.6722409 95.6285956,64.7153892 95.2210044,64.7531441 C94.6019867,64.8088774 94.1934978,64.8389914 93.7872533,64.8632624 C93.1224489,64.9001183 92.7162044,64.9185462 92.3135511,64.9297828 C91.7919422,64.9423677 91.4063467,64.9464433 91.0238933,64.9464433 C90.4641289,64.9450645 90.0740444,64.9378731 89.6871022,64.9261871 C89.0707778,64.9050624 88.6910178,64.8875333 88.3148489,64.8650602 C87.7847111,64.8304516 87.4264978,64.8034839 87.0718756,64.7729204 C86.5776489,64.7293226 86.2127022,64.6906688 85.8508978,64.6493183 C85.2745244,64.5814495 84.9257378,64.5360538 84.58144,64.4866129 C84.0513022,64.4084065 83.7159822,64.3562688 83.3856,64.3005355 C82.9663378,64.2295204 82.6269778,64.1665957 82.29076,64.1014237 C81.7696,63.9989462 81.4472978,63.9315269 81.1294844,63.8618602 C80.6271778,63.7494946 80.3017333,63.6739849 79.9825733,63.5957785 C79.6611689,63.5166731 79.3500889,63.4357699 79.0417022,63.3530688 C78.5797956,63.2281183 78.2938533,63.1476645 78.0128489,63.0658624 C77.5424133,62.9269785 77.2596133,62.8411312 76.9835467,62.7539355 C76.6504711,62.6478624 76.3896667,62.5620151 76.1329022,62.4752688 C75.7320444,62.3395312 75.4775244,62.2505376 75.2283911,62.1606452 C74.8221467,62.0132215 74.5770533,61.9224301 74.3391422,61.8316387 C74.0217778,61.7093849 73.7982311,61.6212903 73.5800711,61.5331957 C73.2600133,61.4037505 73.0409556,61.3125097 72.8263867,61.2217183 C72.4834356,61.0751935 72.2751511,60.9848516 72.0740489,60.8954086 C71.8042667,60.7745032 71.6184267,60.6895548 71.4375244,60.6059548 C71.1843511,60.4881957 71.0065911,60.4036968 70.8337689,60.3200968 C70.5514178,60.1830108 70.38892,60.102557 70.2331556,60.0239011 C69.8242178,59.8166989 69.5212178,59.6580387 69.2482933,59.5101656 C69.0673911,59.4121828 68.9421511,59.3429656 68.8236444,59.2768946 C68.6562089,59.1825075 68.5444356,59.1191333 68.4420889,59.0602538 L7.87844889,24.1091613 C-5.70268444,15.8772581 2.98735556,7.75502366 3.44432444,7.32758495 C19.4710044,-6.03133548 38.2377022,3.35928172 39.2252578,3.85369032 C39.6579867,3.67929892 40.08488,3.51614409 40.50908,3.35793333 C41.23224,3.09185161 41.6465644,2.94397849 42.0550533,2.80599355 C42.5479333,2.64149032 42.9245511,2.52103441 43.2989244,2.40552258 C43.9731556,2.20056774 44.3668311,2.0864043 44.75512,1.97943226 C45.2834622,1.83785161 45.6250667,1.75020645 45.9635289,1.66750538 C46.5879333,1.51693548 46.9623067,1.43288602 47.3312933,1.35512903 C47.8668178,1.24590968 48.1864267,1.18433333 48.5028933,1.12725161 C49.0729822,1.02567312 49.4240133,0.969490323 49.7710044,0.918251613 C50.3204444,0.840494624 50.6220978,0.801391398 50.9192622,0.766782796 C51.4300978,0.707903226 51.7636222,0.675541935 52.0944533,0.647675269 C52.6268356,0.605425806 52.9235511,0.5852 53.2166756,0.56991828 C53.6525467,0.546995699 53.9658711,0.536658065 54.2756044,0.529466667 C54.8192089,0.520027957 55.1213111,0.517780645 55.41668,0.520926882 C55.7542444,0.524972043 56.0424311,0.533511828 56.3270267,0.544748387 C56.8450444,0.567221505 57.1282933,0.582952688 57.4061556,0.603178495 C57.7607778,0.630595699 58.0112578,0.653068817 58.2585956,0.677789247 C58.7258889,0.726780645 58.9898356,0.757793548 59.2483956,0.791952688 C59.6093022,0.842292473 59.8341956,0.876002151 60.0554978,0.911509677 C60.4702711,0.979827957 60.7122222,1.02342581 60.9496844,1.06882151 C61.3119378,1.14118495 61.5094489,1.18253548 61.7038178,1.22523441 C62.0844756,1.31063226 62.3021867,1.36321935 62.5167556,1.41715484 C62.8722756,1.50929462 63.0531778,1.55828602 63.23004,1.60817634 C63.5581778,1.70121505 63.75928,1.76189247 63.9567911,1.82346882 C64.2835822,1.92729462 64.4582,1.98482581 64.6292267,2.04325591 C64.8900311,2.13269892 65.07228,2.19876989 65.2513867,2.26529032 C65.5593244,2.38125161 65.72676,2.44597419 65.8888089,2.51114624 C66.0975422,2.59564516 66.2510622,2.66036774 66.4009911,2.72464086 C66.6837911,2.84734409 66.83372,2.91386452 66.9778133,2.98083441 C67.1721822,3.07117634 67.2951778,3.13050538 67.4150311,3.18893548 C67.6569822,3.30759355 67.7840178,3.37186667 67.9056667,3.43524086 C68.4914667,3.75031398 68.5965067,3.80964301 68.6966089,3.86717419 C68.8869378,3.9781914 69.0049956,4.04785806 69.1145244,4.11482796 C69.2613111,4.20561935 69.3623111,4.26854409 69.4552311,4.32877204 C69.5845111,4.41237204 69.6760844,4.47304946 69.7595778,4.53013118 C70.9006533,4.93734409 71.3414622,4.83756344 71.7795778,4.74047957 C71.9057156,4.7126129 72.0309556,4.68564516 72.1557467,4.65867742 C72.4780489,4.58901075 72.7981067,4.52114194 73.1168178,4.45552043 C73.2487911,4.42855269 73.3807644,4.40068602 73.51184,4.3746172 C73.9261644,4.2910172 74.3377956,4.21056344 74.7458356,4.13415484 C75.2010089,4.04920645 75.6162311,3.97549462 76.0296578,3.90447957 C76.7110711,3.79031613 77.0199067,3.73997634 77.3269467,3.69233333 C78.4846311,3.5147957 79.2903867,3.40467742 80.0826756,3.30804301 C80.71112,3.23388172 81.0064889,3.20062151 81.3005111,3.1696086 C82.0016756,3.0967957 82.3778444,3.05993978 82.7499733,3.02757849 C83.1611556,2.99162151 83.5400178,2.96195699 83.9170844,2.93498925 C84.4992933,2.89543656 84.7888267,2.8770086 85.0765644,2.86082796 C86.09644,2.80644301 86.8191511,2.77947527 87.5292933,2.76374409 C88.0818756,2.75340645 88.3525556,2.75026022 88.6209911,2.74846237 C89.5892444,2.74531613 90.2746978,2.75385591 90.9471333,2.7731828 C91.4359733,2.78891398 91.6994711,2.79880215 91.9607244,2.81003871 C92.5312622,2.83655699 92.8508711,2.85363656 93.16644,2.8734129 C93.4950267,2.89408817 93.8146356,2.91701075 94.1315511,2.94218065 C94.5952533,2.98038495 94.8367556,3.00150968 95.0760133,3.02443226 C95.9298,3.10713333 96.5281689,3.17590108 97.1139689,3.25141075 C97.5350267,3.30714409 97.7671022,3.33950538 97.9973822,3.37276559 C98.7811422,3.48872688 99.33956,3.5804172 99.8845111,3.67884946 C100.270556,3.74986452 100.486022,3.79076559 100.700142,3.83256559 C101.421058,3.97594409 101.936831,4.08696129 102.439138,4.20337204 C102.798698,4.28787097 102.99172,4.33416559 103.182498,4.38135914 C103.857178,4.54990753 104.330307,4.67575699 104.789071,4.80565161 C105.114516,4.89869032 105.296764,4.95172688 105.47632,5.00566237 C106.080973,5.18769462 106.513253,5.32523011 106.932516,5.4650129 C107.224742,5.56344516 107.396218,5.62232473 107.565449,5.68165376 C107.876978,5.79177204 108.067307,5.85964086 108.253147,5.9284086 C108.479836,6.0120086 108.671062,6.08437204 108.858698,6.15673548 C109.129378,6.26190968 109.281551,6.32213763 109.431031,6.38236559 C109.90416,6.5733871 110.252498,6.71991183 110.58692,6.8659871 C110.824382,6.97071183 110.954111,7.02914194 111.082493,7.08712258 C111.345542,7.20667957 111.486942,7.27230108 111.624751,7.33747312 C111.811489,7.42511828 111.958276,7.49613333 112.10192,7.56669892 C112.320978,7.67501935 112.424671,7.72625806 112.52612,7.77749677 C112.767173,7.89975054 112.887027,7.96132688 113.00284,8.02245376 C113.169827,8.10964946 113.294169,8.17616989 113.415818,8.2417914 C113.982764,8.55551613 114.077031,8.60900215 114.169502,8.66203871 C115.996929,9.79738065 116.374893,10.0675075 116.6348,10.2621247 C116.913111,10.473372 117.020396,10.5623656 117.053164,10.5897828 C131.920813,24.5428925 118.730662,34.133071 118.03668,34.6378172 Z",
    id: "Shape",
    fill: "url(#linearGradient-222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.995511,63.8398366 C100.535849,63.9432129 100.079778,64.0362516 99.6255022,64.1238968 C98.9611467,64.2501957 98.5297644,64.324357 98.1010756,64.3922258 C97.4178667,64.4965011 96.9851378,64.5580774 96.556,64.6106645 C96.0375333,64.6722409 95.6281467,64.7153892 95.2205556,64.7531441 C94.6015378,64.8088774 94.1930489,64.8389914 93.7868044,64.8632624 C93.122,64.9005677 92.7157556,64.9185462 92.3131022,64.9297828 C91.7914933,64.9423677 91.4054489,64.9468624 91.0234444,64.9464129 C90.46368,64.9450645 90.0735956,64.9378731 89.6866533,64.9261871 C89.0703289,64.9050624 88.6905689,64.8875333 88.3144,64.8650602 C87.7842622,64.8304516 87.4260489,64.8039333 87.0714267,64.7729204 C86.5772,64.7293226 86.2122533,64.6906688 85.8504489,64.6493183 C85.2740756,64.5814495 84.9252889,64.5360538 84.5809911,64.4866129 C84.0508533,64.4084065 83.7155333,64.3562688 83.3851511,64.3005355 C82.9658889,64.2295204 82.6265289,64.1665957 82.2903111,64.1014237 C81.7691511,63.9989462 81.4468489,63.9315269 81.1290356,63.8618602 C80.6267289,63.7494946 80.3012844,63.6739849 79.9821244,63.5957785 C79.66072,63.5166731 79.34964,63.4357699 79.0412533,63.3530688 C78.5793467,63.2281183 78.2938533,63.1476645 78.0124,63.0658624 C77.5419644,62.9269785 77.2591644,62.8411312 76.9830978,62.7539355 C76.6500222,62.6478624 76.3892178,62.5620151 76.1324533,62.4752688 C75.7315956,62.3395312 75.4770756,62.2505376 75.2279422,62.1606452 C74.8216978,62.0132215 74.5766044,61.9224301 74.3386933,61.8316387 C74.0213289,61.7093849 73.7977822,61.6212903 73.5796222,61.5331957 C73.2595644,61.4037505 73.0405067,61.3125097 72.8259378,61.2217183 C72.4829867,61.0751935 72.2747022,60.9848516 72.0736,60.8954086 C71.8038178,60.7745032 71.6179778,60.6895548 71.4370756,60.6059548 C71.1839022,60.4881957 71.0061422,60.4036968 70.83332,60.3200968 C70.5509689,60.1830108 70.3884711,60.102557 70.2327067,60.0239011 C69.8237689,59.8166989 69.5207689,59.6580387 69.2478444,59.5101656 C69.0669422,59.4121828 68.9417022,59.3429656 68.8231956,59.2768946 C68.65576,59.1825075 68.5439867,59.1191333 68.44164,59.0602538 L7.878,24.1091613 C1.97286667,20.5300925 0.278311111,16.9716989 0.286391111,14.0573849 L0.239677942,30.6133312 C0.231626667,33.5276452 1.92618222,37.0860387 7.83131556,40.6651075 L68.3949556,75.6162 C68.4968533,75.6750796 68.6086267,75.7389032 68.7765111,75.8328409 C68.8945689,75.8989118 69.0202578,75.968129 69.20116,76.0661118 C69.4740844,76.2139849 69.7770844,76.3726452 70.1860222,76.5798473 C70.3413378,76.6580538 70.5038356,76.7385075 70.7866356,76.876043 C70.9594578,76.959643 71.1372178,77.0441419 71.3903911,77.1619011 C71.5712933,77.2459505 71.7571333,77.3304495 72.0269156,77.4513548 C72.2280178,77.5407978 72.4363022,77.6311398 72.7792533,77.7776645 C72.9938222,77.8684559 73.21288,77.9596968 73.5329378,78.0891419 C73.7515467,78.1767871 73.9746444,78.2648817 74.2920089,78.3875849 C74.52992,78.4783763 74.7750133,78.5691677 75.1812578,78.7165914 C75.4303911,78.8064839 75.6849111,78.8954774 76.0857689,79.0312151 C76.3425333,79.1179613 76.6033378,79.2038086 76.9364133,79.3098817 C77.21248,79.3970774 77.49528,79.4829247 77.9657156,79.6218086 C78.24672,79.7036108 78.5326622,79.784514 78.9945689,79.9090151 C79.3029556,79.9912667 79.6140356,80.0726194 79.93544,80.1512753 C80.2546,80.2294817 80.5800444,80.3049914 81.0823511,80.417357 C81.4001644,80.4870237 81.7224667,80.554443 82.2436267,80.6569204 C82.5798444,80.7220925 82.9192044,80.7850172 83.3384667,80.8560323 C83.6688489,80.9117656 84.0041689,80.9639032 84.5343067,81.0421097 C84.8786044,81.0911011 85.2273911,81.1364968 85.8037644,81.2048151 C86.16512,81.2461656 86.5300667,81.2848194 87.0247422,81.3284172 C87.3793644,81.3594301 87.7375778,81.3863978 88.2677156,81.420557 C88.6438844,81.4434796 89.0236444,81.4605591 89.6399689,81.4816839 C90.0269111,81.4933699 90.4169956,81.5005613 90.97676,81.50194 C91.3592133,81.50194 91.7448089,81.4978645 92.2664178,81.4852796 C92.6690711,81.474043 93.0753156,81.4560645 93.74012,81.4187591 C94.1459156,81.3940387 94.5548533,81.3643742 95.1738711,81.3086409 C95.5814622,81.270886 95.9908489,81.2281871 96.5093156,81.1661613 C96.9384533,81.1135742 97.3711822,81.0519978 98.0543911,80.9477226 C98.48308,80.8798538 98.9144622,80.8056925 99.5788178,80.679843 C100.032644,80.5921978 100.488716,80.4991591 100.948378,80.3957828 C114.361627,77.377643 123.305289,69.9224108 123.328631,61.8015247 L123.375316,45.2455785 C123.352422,53.366914 114.40876,60.8216968 100.995511,63.8398366 Z",
    id: "Shape",
    fill: "url(#linearGradient-223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1371511,6.59675914 C38.1371511,6.59675914 21.0735378,-3.7237957 6.75308444,8.14650538 C6.75308444,8.14650538 -1.42118222,15.7451161 10.7109378,23.0987699 L67.2341289,55.0348688 C67.2341289,55.0348688 82.9483822,65.0992301 100.117933,61.2796989 C117.287484,57.4606172 125.333818,44.6221742 114.421778,34.4081419 C114.421778,34.4081419 129.994182,22.6645892 113.805004,10.3785355 C113.805004,10.3785355 98.071,1.25489892 70.0123022,7.35814839 C70.0123022,7.35859785 56.2166,-0.621606452 38.1371511,6.59675914 Z",
    id: "XMLID_1394_",
    fill: "url(#linearGradient-224)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.573333, 73.262366)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61699556,31.7927204 C22.1140622,39.0020968 42.4388533,38.9661398 55.0140267,31.7122667 C67.5892,24.4583935 67.6524933,12.7337183 55.1554267,5.5247914 C42.65836,-1.68413548 22.3335689,-1.64862796 9.75839556,5.60524516 C-2.81677778,12.8586688 -2.88007111,24.5833441 9.61699556,31.7927204 Z",
    fill: "url(#linearGradient-225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6827822,30.0712796 C23.0122889,36.5493806 41.4387289,36.5161204 52.8396089,29.9971183 C64.2404889,23.4781161 64.2983956,12.9413699 52.9688889,6.46326882 C41.6393822,-0.0148322581 23.2129422,0.018427957 11.8120622,6.53743011 C0.411182222,13.0564323 0.353275556,23.592729 11.6827822,30.0712796 Z",
    fill: "url(#linearGradient-226)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.513898,163.087419 C122.513898,163.087419 127.928396,162.889206 134.01892,162.220406 L134.01892,165.936561 C134.01892,165.936561 128.065307,166.80717 122.513898,166.733908 L122.513898,163.087419 Z",
    id: "Shape",
    fill: "url(#linearGradient-227)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.431698,162.065791 C136.431698,162.065791 143.560502,161.183047 147.93672,160.362778 L147.93672,164.078933 C147.93672,164.078933 142.184209,165.2772 136.431698,165.71228 L136.431698,162.065791 Z",
    id: "Shape",
    fill: "url(#linearGradient-228)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3731289,111.548469 L77.2012578,103.313869 C76.6527156,102.994301 76.3156,102.406404 76.3156,101.770865 L76.3156,97.7657054 C76.3156,97.1157828 76.6827911,96.522043 77.2636533,96.2325892 L78.78404,95.4747957",
    id: "Shape",
    stroke: "#FBF8FF",
    strokeWidth: 0.8713,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7128622,114.589082 L94.7128622,120.161516 C94.7128622,120.809641 94.3182889,121.392144 93.7167778,121.631708 L50.4569067,138.838925 C49.8423778,139.083882 49.4388267,139.67897 49.4388267,140.341477 L49.4388267,143.480523",
    id: "Shape",
    stroke: "#FBF8FF",
    strokeWidth: 0.7575,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6106044,138.989495 C37.6106044,138.989495 41.78572,142.426983 45.5900533,144.563727 L45.5900533,149.146895 C45.5900533,149.146895 39.188,144.997458 37.6106044,143.108368 L37.6106044,138.989495 Z",
    id: "Shape",
    fill: "url(#linearGradient-229)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-230)",
    fillRule: "nonzero",
    points: "117.003787 128.378587 80.5549067 107.308241 80.5549067 103.418594 117.003787 124.48894"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.493333, 102.027957)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.85,
    x: 0.322706222,
    y: 0.323118495,
    width: 21.5466667,
    height: 22.4731183,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-231)",
    fillRule: "nonzero",
    points: "14.7240044 15.4664495 7.32811111 11.2032989 7.32811111 7.31365161 14.7240044 11.5768022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.6817422,193.121394 C82.6817422,193.121394 87.4179689,194.389327 93.223,194.763729 L93.223,198.168406 C93.223,198.168406 87.3048489,198.004802 82.6817422,196.461798 L82.6817422,193.121394 Z",
    id: "Shape",
    fill: "url(#linearGradient-232)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7186978,194.816316 C94.7186978,194.816316 99.3359689,195.317916 105.473178,195.368705 L105.473178,198.773383 C105.473178,198.773383 100.095938,199.078568 94.7186978,198.306391 L94.7186978,194.816316 Z",
    id: "Shape",
    fill: "url(#linearGradient-233)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.473627,196.824514 C105.473627,196.837548 115.04708,196.834402 115.04708,196.834402 L115.047978,190.901049 C115.047978,190.299219 114.810516,189.72211 114.387213,189.29512 L91.6931867,169.148419 C91.2227511,168.730869 90.9538667,168.131735 90.9538667,167.502488 L90.9538667,165.047075 C90.9538667,164.237594 91.6667022,163.615987 92.46752,163.727903 C97.0188044,164.364342 110.977004,166.092525 122.514347,165.161239",
    id: "Shape",
    stroke: "#FBF8FF",
    strokeWidth: 0.7575,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1353_",
    transform: "translate(96.511111, 44.496774)",
    fill: "#00E9FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1360_",
    cx: 1.12716,
    cy: 21.3499118,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1359_",
    cx: 56.36608,
    cy: 42.2359785,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1358_",
    cx: 33.4731956,
    cy: 23.5909312,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1357_",
    cx: 20.69288,
    cy: 51.0530817,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1356_",
    cx: 54.2881733,
    cy: 16.5698796,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1355_",
    cx: 3.58482667,
    cy: 0.956455914,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1354_",
    cx: 18.7469467,
    cy: 35.3780817,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1352_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 118.244067,
    cy: 56.376514,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1351_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 153.917267,
    cy: 47.5589613,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1350_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 116.298582,
    cy: 40.7010645,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1349_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 131.024382,
    cy: 28.913914,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1348_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 98.6783467,
    cy: 26.6733441,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1347_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 105.109129,
    cy: 1.20905376,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1346_",
    fill: "#00E9FF",
    fillRule: "nonzero",
    cx: 151.730729,
    cy: 12.8712538,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.653333, 52.137634)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-234)",
    points: "4.89872444 33.3712323 18.1108711 22.1202903 14.1817467 0.643630108 10.3931244 0.222483871 0.392777778 8.73844731"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-235)",
    points: "10.3931244 0.222483871 10.9703956 3.37815914 14.1817467 0.643630108"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-236)",
    points: "3.86807556 13.3418409 12.4315289 6.04976344 12.2766622 5.20342581 3.71320889 12.4955032"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-237)",
    points: "3.22885778 16.6107806 14.0246356 7.41747742 13.8702178 6.57158925 3.07444 15.764443"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-238)",
    points: "3.66024 18.9686602 14.4560178 9.77535699 14.3011511 8.92901935 3.50537333 18.1223226"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-239)",
    points: "4.09162222 21.3260903 14.8874 12.1327871 14.7325333 11.2868989 3.93675556 20.4797527"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-240)",
    points: "4.52300444 23.6839699 15.3187822 14.4906667 15.1639156 13.644329 4.36813778 22.8376323"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-241)",
    points: "4.95438667 26.0414 15.7501644 16.8480968 15.5952978 16.0022086 4.79952 25.1950624"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-242)",
    points: "5.38576889 28.3992796 16.1815467 19.2059763 16.02668 18.3596387 5.23090222 27.5529419"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.893333, 20.675269)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-243)",
    points: "8.23621333 47.2910817 0.00718222222 23.9972452 20.1649867 0.381144086 25.1270044 2.57317204 31.3562356 20.2055806"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-244)",
    points: "25.1270044 2.57317204 22.1652356 6.04302151 20.1649867 0.381144086"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-245)",
    points: "23.7956 23.3832796 18.4614533 8.28538925 19.2559867 7.35500215 24.5896844 22.4528925"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-246)",
    points: "22.2491778 27.863071 15.5248222 8.82878925 16.3189067 7.89840215 23.0437111 26.9322344"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-247)",
    points: "20.0366044 30.4555699 13.3118 11.4212882 14.1063333 10.4909011 20.8306889 29.5247333"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-248)",
    points: "17.8235822 33.0476194 11.0992267 14.0137871 11.8933111 13.0834 18.6176667 32.1172323"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-249)",
    points: "15.61056 35.6401183 8.88620444 16.606286 9.68028889 15.6754495 16.4050933 34.7097312"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-250)",
    points: "13.3979867 38.2326172 6.67318222 19.1987849 7.46771556 18.2679484 14.1920711 37.3022301"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-251)",
    points: "11.1849644 40.8251161 4.46060889 21.7908344 5.25469333 20.8604473 11.9790489 39.894729"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "people_1",
    transform: "translate(461.000000, 246.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.254046,92.3488532 L61.9677272,92.3488532 C66.1485488,92.3488532 70.2537403,91.2335507 73.8632835,89.1176367 L121.890287,61.679389 L78.7216261,35.6382045 L35.254046,92.3488532 Z",
    fill: "url(#linearGradient-252)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.1514045,91.5929761 L87.4055983,63.0854829 C89.0262463,62.1476355 90.0247455,60.4137239 90.0247455,58.5366743 L90.0247455,32.3573187 L84.0017873,25.9784205 L27.4420724,57.7695087 L32.4008051,91.5189236 L32.4008051,91.5189236 C34.1596584,92.5985545 36.3655404,92.6265499 38.1514045,91.5929761 Z",
    fill: "url(#linearGradient-253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.42496992,32.3573187 L0.42496992,68.2321299 C0.42496992,70.5160165 1.6093935,72.6350913 3.5519202,73.8262524 L32.400355,91.5193751 C33.6500546,92.2860892 35.254046,91.3839133 35.254046,89.9146039 L35.254046,63.7262175 L0.42496992,32.3573187 Z",
    fill: "url(#linearGradient-254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6409003,63.8693555 L89.0568585,33.9503499 C90.198515,33.2861354 90.3614801,31.6976195 89.3787372,30.8139568 L56.442668,1.19567653 C55.3536826,0.216738947 53.7604956,0.0519270395 52.4954898,0.787936382 L1.80927342,30.2820433 C0.17647056,31.2320823 -0.05672268,33.5037774 1.34873928,34.7676364 L33.1998746,63.4105914 C34.4248144,64.5123477 36.2178814,64.6974789 37.6409003,63.8693555 Z",
    fill: "url(#linearGradient-255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2630491,60.797984 L85.4621712,33.3330955 C86.5101902,32.7230657 86.6601002,31.2650447 85.7579395,30.4540798 L56.0469598,3.73694068 C55.0475602,2.83792559 53.5844752,2.68711141 52.423461,3.36261446 L5.89420674,30.4378244 C4.39555752,31.3101986 4.18127184,33.3954079 5.47148772,34.5558644 L34.1866692,60.3776007 C35.3107687,61.3881461 36.9566267,61.5583764 38.2630491,60.797984 Z",
    fill: "url(#linearGradient-256)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.2878023,25.5137864 L27.9894913,54.88959 L33.9741842,60.2714889 C33.9741842,60.2714889 36.0306065,62.1178339 38.4152099,60.7302531 C40.7998134,59.3426722 85.3424233,33.4857158 85.3424233,33.4857158 C85.3424233,33.4857158 87.3461745,31.8615283 85.664302,30.3493226 C83.9833299,28.8371169 80.2878023,25.5137864 80.2878023,25.5137864 Z",
    fill: "url(#linearGradient-257)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.8993032,19.4929591 C39.0175508,18.1162152 36.3587877,17.7405344 34.528806,18.7506282 C33.0922816,19.5435315 32.5768255,20.9645262 33.0639203,22.397261 C31.710229,23.4294802 31.6994247,25.2099004 33.098134,26.6376682 C34.5877796,28.1584531 37.1430013,28.6641773 38.7776048,27.7615499 L45.2129279,24.2088373 C46.6003827,23.4425749 46.6949205,21.8274182 45.4326158,20.5387245 C44.2580962,19.3403387 42.2277844,18.9014424 40.8993032,19.4929591 L40.8993032,19.4929591 Z M39.5775747,22.3503009 L41.3818961,24.1921304 L39.4020045,25.2853074 L37.5976831,23.4434779 L36.1134396,24.2630221 L36.3331274,20.5929092 L41.0649694,21.5294021 L39.5775747,22.3503009 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8993032,19.4929591 C39.0175508,18.1162152 36.3587877,17.7405344 34.528806,18.7506282 C33.0922816,19.5435315 32.5768255,20.9645262 33.0639203,22.397261 C31.710229,23.4294802 31.6994247,25.2099004 33.098134,26.6376682 C34.5877796,28.1584531 37.1430013,28.6641773 38.7776048,27.7615499 L45.2129279,24.2088373 C46.6003827,23.4425749 46.6949205,21.8274182 45.4326158,20.5387245 C44.2580962,19.3403387 42.2277844,18.9014424 40.8993032,19.4929591 L40.8993032,19.4929591 Z M39.5775747,22.3503009 L41.3818961,24.1921304 L39.4020045,25.2853074 L37.5976831,23.4434779 L36.1134396,24.2630221 L36.3331274,20.5929092 L41.0649694,21.5294021 L39.5775747,22.3503009 Z",
    id: "Shape",
    fill: "url(#linearGradient-258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2201279,28.7964784 L37.3478332,43.6489663 C35.3936018,44.7710419 32.655607,44.7859427 31.2321379,43.6828318 L31.2321379,43.6828318 C29.8091189,42.5797208 30.239491,40.7758206 32.1937223,39.653745 L58.0660171,24.8012571 C60.0202485,23.6791815 62.7582433,23.6642807 64.1817124,24.7673917 L64.1817124,24.7673917 C65.6047314,25.8705026 65.1743593,27.6744028 63.2201279,28.7964784 Z",
    id: "Shape",
    fill: "#E1FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8446778,28.9278764 L37.0835775,43.7343073 C35.1374494,44.8527705 32.4782361,44.8243236 31.1430022,43.6706402 L31.1430022,43.6706402 C29.8082185,42.5169568 30.3034165,40.6751273 32.2490945,39.5566641 L58.0101948,24.7506847 C59.9563229,23.6322214 62.6155362,23.6606684 63.9507701,24.8143518 L63.9507701,24.8143518 C65.286004,25.9680351 64.790806,27.8098646 62.8446778,28.9278764 Z",
    id: "Shape",
    fill: "url(#linearGradient-259)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.770700, 48.314724)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-260)",
    cx: 20.523256,
    cy: 36.1516049,
    rx: 20.4845405,
    ry: 5.16516004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3828013,2.26176122 C11.3828013,2.26176122 7.59588714,14.0654546 7.41491478,17.2433894 C7.23394242,20.4213242 7.41491478,35.6743277 7.41491478,35.6743277 C7.41491478,35.6743277 5.87619954,36.2188843 3.9750894,35.6743277 C2.07397926,35.1297711 2.88880506,37.308449 5.15185992,37.7626977 C7.41491478,38.2169464 10.5828314,39.2153002 10.5828314,38.3980138 C10.5828314,37.5807273 10.6733176,34.3124846 10.4923453,33.5859576 C10.3113729,32.8594306 13.2983172,19.1497891 13.2983172,19.1497891 L19.1272478,7.89155538 L21.1737661,34.403244 C21.1737661,34.403244 15.7842112,33.2956177 15.8746973,34.294423 C15.9651835,35.2932283 21.4677337,37.4750671 22.9020071,37.2023372 C24.3367308,36.9300589 24.8845999,21.9646862 24.9755362,18.6052325 C25.0664726,15.2457788 26.6218445,0.355813105 26.6218445,0.355813105 L11.3828013,2.26176122 Z",
    id: "Shape",
    fill: "url(#linearGradient-261)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.302209,17.7107328 C74.302209,17.7107328 78.8269682,19.2531916 81.3632823,26.8801449 C83.3112112,32.7375149 80.0928743,41.5885917 78.8269682,41.4070728 C77.561062,41.2255539 74.302209,17.7107328 74.302209,17.7107328 Z",
    id: "Shape",
    fill: "url(#linearGradient-262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4831809,25.7783886 C77.4831809,25.7783886 80.1288887,29.5103623 78.5050895,36.1317371 C78.5050895,36.1317371 74.7361825,31.1395167 77.4831809,25.7783886 Z",
    id: "Shape",
    fill: "#0653CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5715683,11.9897276 C64.5715683,11.9897276 63.5307521,17.7549836 66.4726784,17.255581 C66.4726784,17.255581 66.9251093,19.5254699 66.8800913,20.2971509 C66.8346232,21.0688318 70.8178158,19.389105 70.8628338,18.0728674 C70.9078518,16.7561783 71.1342923,13.4879356 69.4596227,11.6266899 C67.7849531,9.7654442 65.4314121,9.72029025 64.5715683,11.9897276 Z",
    id: "Shape",
    fill: "#FFDEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9953374,7.68249261 C66.9953374,7.68249261 64.7926067,8.05727037 63.7963583,7.40795661 C62.80011,6.75864284 61.5067429,7.80847212 61.9708784,10.3226439 C62.435014,12.8368157 63.0414065,13.1289617 63.5748698,13.0165284 C64.1083331,12.9045466 65.3166162,13.6324283 65.653801,14.2894182 C65.9909858,14.9464081 66.158903,15.5121871 66.3209678,14.4686794 C66.4830326,13.4251716 67.2159256,13.3484099 67.5004394,14.3052221 C67.7849531,15.2624858 67.6701572,16.6229742 68.6069818,16.4373915 C69.5438064,16.2518087 71.2031699,16.7503083 71.9095023,14.3598583 C72.6153845,11.9698599 70.598128,7.40976276 66.9953374,7.68249261 Z",
    id: "Shape",
    fill: "url(#linearGradient-263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7582457,24.056217 C47.7582457,24.056217 47.6348963,23.6398976 47.5466611,22.792358 C47.4584258,21.9448184 47.9810848,21.2169368 47.866739,21.1352081 C47.7523933,21.0534795 47.4125074,21.0701865 47.1320453,21.4409004 C46.8515831,21.8116143 46.0777237,19.5977162 45.6788642,19.5028929 C45.2800048,19.4085212 45.7229819,20.8493837 45.840929,21.1934567 C45.9588762,21.5375298 45.1521536,21.7741365 44.9999928,22.7901003 C44.847832,23.8060641 45.8999026,24.8360257 45.8999026,24.8360257 L47.7582457,24.056217 Z",
    id: "Shape",
    fill: "#FFDEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9819851,23.6841485 C47.9819851,23.6841485 51.9048536,29.787156 54.2813539,29.5600316 C56.5952791,29.3387773 58.0372056,25.8664387 60.9966889,23.7410424 C63.5744196,21.8897306 66.0157457,21.2553176 66.8796412,20.7062456 C68.7352831,19.5259215 70.4374137,18.3912028 71.9626235,17.7102812 C73.4878334,17.0293597 75.1170348,17.8466462 76.2033191,19.1628837 C77.2896035,20.4795728 79.8412237,44.6757671 78.3929947,48.6705368 C76.9447656,52.6653065 75.0265486,50.3954176 68.7204272,52.2417625 C62.8986994,53.9458725 63.0760703,52.8468254 63.182763,48.8520557 C63.2894557,44.8572859 65.1104338,39.0464244 64.3928468,35.535705 C63.6752599,32.0249856 64.2501398,28.7689345 61.8736396,30.4382759 C60.1553025,31.6452409 57.325471,33.573766 54.3479805,33.7868927 C51.1791635,34.014017 47.6592061,30.4315028 45.5627178,24.9042081 L47.9819851,23.6841485 Z",
    id: "Shape",
    fill: "url(#linearGradient-264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7676956,17.1652731 C71.7676956,17.1652731 69.3889445,18.4616429 68.0564117,18.5727216 C66.7238789,18.6838003 66.7436868,20.2976024 66.8796412,20.7062456 C67.0155955,21.1148889 70.8623836,19.6622864 71.4507689,18.9357594 C72.0396043,18.2092324 72.0846223,17.8005891 71.7676956,17.1652731 Z",
    id: "Shape",
    fill: "url(#linearGradient-265)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInImage);
export default __webpack_public_path__ + "static/media/sign-in-image.0fdb656eada57bb59dbb052fb9e91820.svg";
export { ForwardRef as ReactComponent };